<template>
    <div class="active-chart-table-container" style="display: flex; flex-wrap: wrap; margin-left: 0; background-color: white; margin-left: 1em; border-radius: 8px; overflow-y: auto">
        <div class="chart-approval-only" style="height: 70vh;display: flex; flex-wrap: wrap; margin-left: 0; width: 100%; border-radius: 8px;" :style="loadingPatient || !patient || loadingResidentDrugs ? {backgroundColor: '#f3f4f4'}:{}">
            <div v-if="!loadingPatient && !loadingResidentDrugs && patient && patient.personal_information && patient.regulatory_information" style="width: 100%">
                <div class="admin-chart-form-container">
                    <div class="admin-chart-form" >
                        <!-- PATIENT SUMMARY HEADER -->
                        <!-- GENERAL INFO -->
                        <div class="general-patient"
                            style="grid-area: initial; border-top-left-radius: 8px; border-bottom-left-radius: 8px; display: grid; grid-template-columns: 1fr 4fr; grid-gap: 10px;">
                            <div>
                                <router-link :to="'/patient/' + patient.uuid" style="text-decoration: none; color: #0870DC">
                                    <h2 class="selected-resident-name" style="padding-top: 0px; margin: 0; color: #0870DC; font-size: 1.2em;">
                                        {{ patient.personal_information.first_name }} {{ patient.personal_information.last_name }}
                                    </h2>
                                </router-link>
                                <div v-if="patient.personal_information?.similar_sounding_name" class="similar-name-tag-patient-general">⚠️ Similar Sounding Name</div>
                               
                                <img class="resident-image large admin" onerror="this.onerror=null; this.className='resident-image-default resident-image large admin'" v-if="patient.image_information && patient.image_information.item" :src="patient.image_information.url">
                                <img v-else class="resident-image-default resident-image large admin">
                                <Button class="black-button" 
                                style="width: 100%; margin: 0 auto; margin-top: 12px; margin-bottom: 12px; border-radius: 4px;  color: white; font-size: 0.9em; text-align: center; overflow: hidden; display: flex; align-items: center; justify-content: center;"
                                @click="viewFMhrFile">
                                <svg width="20" height="20" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M26 13.0711C24.809 14.1963 23.6139 15.3182 22.4294 16.4494C22.2036 16.665 21.9883 16.8606 21.6337 16.8027C21.5248 16.7103 21.5581 16.5866 21.5581 16.4741C21.5551 15.573 21.5576 14.6714 21.5546 13.7702C21.5546 13.6731 21.5989 13.5369 21.4939 13.4911C21.3845 13.4435 21.3149 13.5756 21.2353 13.6353C20.8325 13.9373 20.5426 14.3456 20.1522 14.6588C20.0065 14.7754 19.8961 14.9411 19.6852 14.9738C19.6808 14.8753 19.5952 14.8291 19.5326 14.7703C19.0184 14.2854 18.5017 13.8033 17.987 13.3185C17.7199 13.0669 17.7174 12.8891 17.981 12.6413C19.1576 11.5357 20.3347 10.4316 21.5128 9.32788C21.7789 9.07867 21.9689 9.07914 22.2304 9.32414C23.3966 10.4176 24.5608 11.5124 25.73 12.6026C25.8374 12.7024 25.9035 12.8261 25.9995 12.9306V13.0706L26 13.0711Z" fill="#D3D3D3"/>
                                    <path d="M17.4514 20.9594C17.4514 20.9729 17.4514 20.9865 17.4494 20.9995H17.3002C17.0909 20.8614 16.9198 20.6841 16.7403 20.5156C15.6691 19.5122 14.5984 18.5079 13.5287 17.5032C13.2223 17.2152 13.2213 17.0636 13.5227 16.7807C14.6864 15.6883 15.8501 14.5962 17.0143 13.5042C17.3146 13.2223 17.4768 13.2251 17.7851 13.5112C18.3669 14.0507 18.9498 14.5892 19.5316 15.1282C19.5495 15.153 19.5515 15.1782 19.5381 15.2052C19.3929 15.4045 19.1979 15.4908 18.9393 15.4414C18.7628 15.4073 18.6141 15.4586 18.4868 15.5767C18.2043 15.8395 17.9248 16.1045 17.6424 16.3673C17.5081 16.4923 17.4703 16.6421 17.4708 16.813C17.4743 18.1267 17.4673 19.4399 17.4753 20.7536C17.4753 20.8231 17.4882 20.8936 17.4519 20.9594H17.4514Z" fill="#EE4120"/>
                                    <path d="M0.0407788 16.9021L0.0188975 16.9063L0 16.8956V13.444C0.0154164 13.444 0.0303355 13.4431 0.0452545 13.4403C0.141731 13.5252 0.128801 13.6381 0.129299 13.7445C0.132283 14.6966 0.132283 15.6481 0.129299 16.6001C0.129299 16.7061 0.142229 16.8199 0.0412761 16.9021H0.0407788Z" fill="#74AC8E"/>
                                    <path d="M4.12606 21C4.12705 20.9869 4.12705 20.9739 4.12606 20.9608C4.15092 20.9239 4.18971 20.9113 4.23248 20.9053C4.29116 20.9029 4.34487 20.9113 4.38117 20.9613C4.37919 20.9743 4.3772 20.9874 4.37471 21H4.12606Z" fill="#BCDB9A"/>
                                    <path d="M10.7934 10.9463C10.8918 10.9132 10.9505 10.8343 11.0202 10.7694C11.5483 10.2766 12.0734 9.78102 12.6016 9.28821C12.8458 9.06047 13.0357 9.05953 13.2829 9.29101C14.4724 10.404 15.661 11.5185 16.848 12.6343C17.1012 12.8723 17.0982 13.0506 16.8421 13.2909C15.6605 14.4007 14.4774 15.509 13.2948 16.6179C13.163 16.7411 13.0288 16.8592 12.8209 16.7602C12.8806 15.6131 12.8383 14.4651 12.8433 13.3175C12.8438 13.2013 12.8229 13.0856 12.7697 12.9782C12.7189 12.8434 12.617 12.743 12.5121 12.6432C11.9407 12.0967 11.3434 11.574 10.7909 11.0093C10.7805 10.9879 10.7814 10.9669 10.7934 10.9463Z" fill="#32A1DA"/>
                                    <path d="M4.38116 20.9608C4.32795 20.9566 4.27473 20.9524 4.22152 20.9482C4.17428 20.8348 4.20511 20.7177 4.20511 20.6024C4.20312 19.3769 4.19964 18.1514 4.2076 16.9259C4.20909 16.6837 4.13748 16.4933 3.94651 16.3271C3.67996 16.0952 3.42833 15.8479 3.17271 15.6052C3.04192 15.481 2.8987 15.4129 2.70674 15.4512C2.45908 15.5002 2.27011 15.4134 2.13832 15.2127C2.12489 15.187 2.1239 15.1604 2.13584 15.1338C2.71768 14.593 3.29952 14.0525 3.88137 13.5117C4.17726 13.2363 4.33789 13.2349 4.6308 13.5093C5.79598 14.6014 6.96067 15.6939 8.12535 16.7863C8.43616 17.078 8.43716 17.2185 8.13082 17.506C6.96663 18.5989 5.80195 19.6914 4.63727 20.7835C4.56218 20.8539 4.49603 20.9379 4.38215 20.9603L4.38116 20.9608Z" fill="#8BC440"/>
                                    <path d="M17.3848 10.3634C17.3848 9.72642 17.3892 9.0894 17.3818 8.45238C17.3793 8.25964 17.4429 8.1117 17.5921 7.97823C17.8915 7.71036 18.1844 7.43502 18.4699 7.15361C18.6041 7.02107 18.7553 6.95854 18.9363 7.01641C19.1537 7.08594 19.2949 7.00101 19.4396 6.8638C20.0448 6.28932 20.656 5.7195 21.2667 5.15015C21.3458 5.07642 21.4224 4.95695 21.5541 5.01575C21.671 5.06755 21.6292 5.19449 21.6292 5.29156C21.6312 6.30939 21.6277 7.32675 21.6322 8.34458C21.6337 8.65025 21.5203 8.90366 21.2926 9.1174C20.1035 10.2318 18.915 11.3472 17.7254 12.4612C17.6573 12.5251 17.5906 12.6254 17.4797 12.5872C17.3519 12.5428 17.3867 12.4178 17.3862 12.3216C17.3838 11.6692 17.3848 11.0163 17.3848 10.3639V10.3634Z" fill="#F6931E"/>
                                    <path d="M8.45057 16.7093C8.371 16.6417 8.28845 16.5773 8.21236 16.5063C7.08697 15.4521 5.96207 14.3969 4.83816 13.3409C4.76257 13.2699 4.69544 13.191 4.62482 13.1154C4.52238 12.9278 4.58305 12.7696 4.72876 12.6306C5.26833 12.1153 5.81487 11.6062 6.3609 11.0971C6.45788 11.0065 6.5643 10.9641 6.69559 11.0289C6.83533 11.098 6.98054 11.0971 7.13123 11.0681C7.24958 11.0453 7.37093 11.0565 7.46243 11.1302C7.88116 11.4676 8.26657 11.8367 8.62463 12.232C8.58136 12.1653 8.58235 12.0859 8.58235 12.0066C8.58235 11.1988 8.58186 10.391 8.58285 9.58268C8.58285 9.49774 8.5744 9.40861 8.62313 9.33207C8.66988 9.2588 8.71265 9.28587 8.74597 9.34747C8.77382 9.41421 8.7773 9.48421 8.7773 9.55375C8.77929 10.523 8.78128 11.4923 8.7763 12.4616C8.7763 12.5237 8.77034 12.5858 8.75741 12.6469C8.70469 12.7902 8.72757 12.9376 8.72757 13.0846C8.73005 14.1701 8.73005 15.2556 8.72757 16.3407C8.72757 16.4261 8.72757 16.5124 8.69325 16.5931C8.64949 16.6981 8.58484 16.7705 8.44958 16.7093H8.45057Z" fill="#BEBEBE"/>
                                    <path d="M8.69093 9.29147C8.62031 9.37361 8.65214 9.47068 8.65164 9.56075C8.64915 10.4806 8.65015 11.4009 8.65015 12.3375C8.28761 11.9287 7.88082 11.5913 7.50337 11.2282C7.39098 11.1204 7.2572 11.0863 7.09558 11.1372C6.94987 11.1829 6.79571 11.1811 6.67088 11.0854C6.5759 11.0126 6.51771 11.035 6.44163 11.1064C5.88216 11.6347 5.3217 12.162 4.75776 12.6861C4.62498 12.8098 4.61305 12.9572 4.62498 13.1154C4.45242 12.9241 4.37782 12.6982 4.37732 12.4528C4.37484 11.4368 4.37633 10.4208 4.37583 9.40534C4.37583 9.30407 4.35992 9.18694 4.47629 9.1384C4.60907 9.08333 4.68615 9.1944 4.76472 9.26767C5.3217 9.78709 5.87968 10.3051 6.4287 10.832C6.54805 10.9463 6.6132 10.9552 6.73703 10.8352C7.27312 10.3186 7.82313 9.81462 8.36271 9.30081C8.4751 9.19347 8.58948 9.12347 8.75408 9.1566C8.77398 9.21867 8.7506 9.26254 8.69043 9.29147H8.69093Z" fill="#D3D3D3"/>
                                    <path d="M8.45065 16.7093C8.66399 16.7075 8.64808 16.5586 8.64858 16.4289C8.65057 15.5538 8.64957 14.6788 8.64957 13.8038C8.64957 13.4939 8.64808 13.1845 8.65057 12.8746C8.65106 12.7995 8.6252 12.7183 8.69085 12.653C8.81119 12.7421 8.80125 12.8933 8.88181 13.0016C8.93254 13.1019 9.01807 13.1756 9.09963 13.2526C9.61931 13.7403 10.1395 14.2275 10.6582 14.7157C10.7278 14.781 10.8069 14.8394 10.8521 14.9252C10.8586 14.9486 10.8521 14.9682 10.8342 14.9845C10.2355 15.5394 9.63721 16.0947 9.03697 16.6482C8.8286 16.8405 8.68637 16.8531 8.45065 16.7098V16.7093Z" fill="#D3D3D3"/>
                                    <path d="M8.84461 13.03C8.74515 12.9218 8.72128 12.786 8.69095 12.653C8.69095 11.5325 8.69095 10.412 8.69095 9.29194C8.71233 9.24714 8.73322 9.20187 8.7546 9.15707C8.89136 9.13653 8.96446 9.22894 9.04503 9.30454C9.62836 9.85149 10.2107 10.3989 10.794 10.9463C10.7945 10.9575 10.7955 10.9692 10.7965 10.9804C10.8025 11.0989 10.7005 11.154 10.6284 11.2226C10.2062 11.623 9.78203 12.0225 9.35435 12.4182C9.15593 12.6021 8.95452 12.7813 8.84561 13.03H8.84461Z" fill="#5080A6"/>
                                    <path d="M19.531 15.1684C19.532 15.1553 19.5325 15.1418 19.5315 15.1287C19.5827 15.0774 19.6339 15.026 19.6846 14.9747C20.2178 14.4791 20.7504 13.983 21.285 13.4888C21.3586 13.4207 21.4292 13.3115 21.552 13.3675C21.6569 13.4155 21.6281 13.5299 21.6281 13.6204C21.6306 14.6812 21.6321 15.7419 21.6336 16.8027C21.6162 16.8652 21.6336 16.9371 21.5764 16.9889C21.4943 17.0477 21.4322 16.995 21.3814 16.9478C20.7688 16.3803 20.1536 15.8157 19.5583 15.2318C19.5414 15.215 19.535 15.1912 19.531 15.1679V15.1684Z" fill="#A12426"/>
                                    <path d="M10.8343 14.984C10.8323 14.97 10.8293 14.9565 10.8259 14.9425C10.8507 14.8454 10.9353 14.7899 11.0044 14.725C11.4291 14.3241 11.8543 13.9237 12.2825 13.5261C12.4868 13.3367 12.7017 13.1565 12.7788 12.8812C12.8956 13.0132 12.9275 13.1691 12.9275 13.3353C12.9275 14.3895 12.9275 15.4437 12.9275 16.4975C12.9275 16.5969 12.9473 16.7042 12.8215 16.7597C12.6907 16.7485 12.6276 16.6468 12.5475 16.5731C11.9751 16.0448 11.4057 15.5137 10.8353 14.9836L10.8343 14.984Z" fill="#1F6DB0"/>
                                    <path d="M2.13532 15.1343C2.13184 15.1469 2.13135 15.159 2.13334 15.1716C2.11991 15.2556 2.05078 15.3042 1.99359 15.3583C1.44954 15.8703 0.905495 16.3817 0.359457 16.8909C0.283867 16.9614 0.21126 17.0402 0.0924051 17.0472C0.0411829 17.009 0.0531181 16.9516 0.0411829 16.9016C0.0426748 15.7475 0.0441667 14.5939 0.0456586 13.4398C0.160038 13.2643 0.257012 13.3927 0.336083 13.4655C0.726466 13.8234 1.10939 14.1888 1.49729 14.55C1.70814 14.7465 1.92298 14.9397 2.13582 15.1343H2.13532Z" fill="#006630"/>
                                    <path d="M19.5311 15.1684C20.1328 15.671 20.6729 16.2324 21.2537 16.7546C21.3517 16.8424 21.4193 16.9716 21.5765 16.9894C21.5476 17.1821 21.4372 17.3319 21.295 17.4654C20.104 18.5821 18.9129 19.6989 17.7224 20.8161C17.6458 20.888 17.5712 20.9608 17.4514 20.9599C17.3897 20.8693 17.3957 20.7681 17.3957 20.6668C17.3957 19.3694 17.3986 18.0721 17.3932 16.7747C17.3922 16.5903 17.4479 16.448 17.5906 16.3201C17.89 16.0518 18.1799 15.7746 18.4698 15.4974C18.5827 15.3891 18.7225 15.313 18.8692 15.3639C19.1556 15.4624 19.3406 15.3233 19.5306 15.1693L19.5311 15.1684Z" fill="#B01020"/>
                                    <path d="M0.0920787 17.0477C0.699285 16.4839 1.30649 15.9197 1.91469 15.3564C1.98432 15.292 2.0604 15.2332 2.13351 15.1716C2.32944 15.362 2.54478 15.4656 2.83918 15.363C2.95406 15.3228 3.05899 15.4026 3.14452 15.4834C3.47175 15.7919 3.79897 16.1003 4.12819 16.4069C4.23511 16.5063 4.27837 16.6225 4.27837 16.763C4.27638 18.0763 4.27688 19.3895 4.27738 20.7023C4.27738 20.7886 4.27539 20.8731 4.22218 20.9487C4.19035 20.9524 4.15852 20.9566 4.1267 20.9603C4.02674 20.9305 3.96457 20.8558 3.89445 20.7905C2.73475 19.704 1.57553 18.6167 0.41632 17.5298C0.269118 17.3921 0.127387 17.2516 0.0920787 17.0477Z" fill="#005926"/>
                                    <path d="M12.7782 12.8816C12.7827 13.0076 12.7802 13.135 12.6773 13.2298C12.0596 13.8001 11.4713 14.3988 10.8258 14.9425C10.2037 14.3638 9.58055 13.7861 8.96091 13.2051C8.91018 13.1579 8.88283 13.0888 8.84454 13.03C8.8336 12.8606 8.92311 12.7402 9.04644 12.6254C9.63227 12.0794 10.2131 11.5292 10.7955 10.9804C11.4668 11.5544 12.0879 12.1756 12.7295 12.7776C12.7558 12.8023 12.7623 12.8466 12.7782 12.8816Z" fill="#18619A"/>
                                    </svg>
                                    <span style="flex: 1; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; margin-left: 10px;">View My Health Record</span>
                                </Button>
                                <MiniViewMhr v-if="openMhrMiniView" :patient="this.patient" @close="viewFMhrFile"/>
                                <button class="prn-button" @click="showPRN()" :style="patient.displayPRN ? {color: 'white', backgroundColor: '#00B2A2'}:{color: '#00B2A2', backgroundColor: 'white'}"
                                style="width: 100%; border: 2px solid #00B2A2;  font-weight: bold;">PRN</button>
                                <button class="nim-button" @click="showNIM()" 
                                :style="patient.displayNIM ? {color: 'white', backgroundColor: '#274188'}:{color: '#274188', backgroundColor: 'white'}"
                                style="width: 100%; border: 2px solid #274188;  font-weight: bold;">NIM</button>
                                <button class="daily-doses-button" @click="showDailyDoses()" 
                                :style="patient.displayDailyDoses ? {color: 'white', backgroundColor: '#274188'}:{color: '#274188', backgroundColor: 'white'}"
                                style="width: 100%; border: 2px solid #274188;  font-weight: bold; margin-top: 5px;">Daily Doses</button>
                                <div style="margin-top: 5px; width: 100%;">
                                    <Dropdown
                                        v-model="selectedAdhocReading"
                                        :options="adhocReadingOptions"
                                        optionLabel="label"
                                        optionValue="value"
                                        placeholder="Add Clinical Reading..."
                                        style="width: 100%; border: 2px solid #0870DC; font-weight: bold;"
                                        @change="openAdhocReadingModal"
                                    />
                                </div>
                                <button class="daily-doses-button" @click.prevent="displayReadingsModal = true"
                                :style="displayReadingsModal ? {color: 'white', backgroundColor: '#274188'}:{color: '#274188', backgroundColor: 'white'}"
                                style="width: 100%; border: 2px solid #274188; font-weight: bold; margin-top: 5px; padding: 5px 0; border-radius: 4px; cursor: pointer; font-size: 14.4px; font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;">View Clinical Readings</button>
                                <ReadingsModal
                                    v-if="displayReadingsModal"
                                    :patientId="patient && patient.uuid ? patient.uuid : ''"
                                    @close="displayReadingsModal = false"
                                />
                                <!-- <button class="outline-button" @click="showPatch()" :style="patient.displayPatch ? {color: 'white', backgroundColor: '#EF9600'}:{color: '#EF9600', backgroundColor: 'white'}"
                                style="width: 100%; border: 2px solid #EF9600;  font-weight: bold;">PATCH</button> -->
                                <div>
                                    <div :class="infoADRTab == 'INFO' ? 'info-tab-border': 'adr-tab-border'">
                                        <!-- PATIENT INFO/ADR TAB SELECT -->
                                        <div style="display: flex; justify-content: space-around; align-items: center;" class="adr-tab-bottom">
                                            <h4 style="width: 100%; margin: 0; padding: 5px 0;" class="adr-tab">
                                                ADR</h4>
                                        </div>
                                        <!-- PATIENT STICKERS -->
                                        <div style="height: 130px; overflow: auto; cursor: pointer;" v-if="infoADRTab == 'ADR'" @click="displayADRModal = true">
                                            <table style="padding: 0 10px; border-collapse: collapse;" v-if="realAdrs.length">
                                                <tr>
                                                    <th style="border-bottom: 2px solid #b6b6b6; padding: 0 10px;">
                                                        Drug
                                                    </th>
                                                    <th style="border-bottom: 2px solid #b6b6b6; padding: 0 10px;">
                                                        Year
                                                    </th>
                                                </tr>
                                                <tr v-for="(item, index) in realAdrs" :key="index">
                                                    <td style="padding: 0 10px;">
                                                        {{ item.drug ? item.drug.toUpperCase() : item.custom ? item.custom.toUpperCase() : 'Non Spec.'}}
                                                    </td>
                                                    <td style="padding: 0 10px;">
                                                        {{ item.date ? item.date.split(',')[1] : '----' }}
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                        <!-- PATIENT INFO -->
                                        <!-- <div style="height: 130px; text-align: left; overflow-x: auto; background-color: white !important;border-radius: 8px"
                                            v-if="infoADRTab == 'INFO'">
                                            <div>
                                                <div class="general-patient-info">
                                                    <p class="general-patient-info-key">DOB</p>
                                                    <p class="general-patient-info-value">{{ patient.personal_information.dob }} ({{ patient.personal_information.age }} yo)</p>
                                                </div>
                                                <div class="general-patient-info">
                                                    <p class="general-patient-info-key">Sex</p>
                                                    <p class="general-patient-info-value">{{ patient.personal_information.sex }}</p>
                                                </div>
                                                <div class="general-patient-info">
                                                    <p class="general-patient-info-key">Preferred Name</p>
                                                    <p class="general-patient-info-value">
                                                        {{ patient.personal_information.preferred_name }}</p>
                                                </div>
                                                <div class="general-patient-info">
                                                    <p class="general-patient-info-key">Height:</p>
                                                    <p 
                                                        class="general-patient-info-value"
                                                        v-if="patient.latest_height_reading?.value && patient.latest_height_reading.value != 0"
                                                    >{{ patient.latest_height_reading.value }} cm</p>
                                                    <p 
                                                        class="general-patient-info-value"
                                                        v-else
                                                    >Unknown</p>
                                                </div>
                                                <div class="general-patient-info">
                                                    <p class="general-patient-info-key">Weight:</p>
                                                    <p 
                                                        class="general-patient-info-value"
                                                        v-if="patient.latest_weight_reading?.value && patient.latest_weight_reading.value != 0"
                                                    >{{ patient.latest_weight_reading.value }} kg</p>
                                                    <p 
                                                        class="general-patient-info-value"
                                                        v-else
                                                    >Unknown</p>
                                                </div>
                                                <div class="general-patient-info" v-for="(item, index) in patient.contact_methods"
                                                    :key="index">
                                                    <p class="general-patient-info-key">{{ item.type }}</p>
                                                    <p class="general-patient-info-value">{{ item.data }}</p>
                                                </div>
                                                <div class="general-patient-info"
                                                    v-for="(item, index) in patient.regulatory_information" :key="index">
                                                    <p class="general-patient-info-key">{{ item.regulatory_type }}</p>
                                                    <p class="general-patient-info-value">{{ item.data }}</p>
                                                </div>
                                            </div>
                                        </div> -->
                                    </div>
                                    <!-- SPECIAL CONSID.-->
                                    <div>
                                        <div v-if="spec_cons && $store.state.user.patient_admin_active">
                                            <div
                                                v-if="spec_cons.special_considerations && spec_cons.special_considerations.length"
                                                style="display: flex; flex-wrap: wrap; padding: 5px; background-color: white; border-radius: 8px; margin-top: 2px; overflow: auto; max-height: 200px;"
                                            >
                                                <p
                                                    class="field-value"
                                                    v-for="(item, index) in uniqueSpecCons" :key="index"
                                                    style="color: white; font-weight: bold; background-color: #E04F39; border-radius: 30px; height: fit-content; padding: 3px 10px; margin-top: 0px; margin-right: 5px;"
                                                >
                                                    {{item.name.toUpperCase() }}
                                                </p>
                                            </div>
                                            <div style="padding: 10px; border-radius: 4px; border: 2px solid red" v-if="spec_cons.comments">
                                                <span style="font-weight: bold; text-align: left;">Notes: </span>{{ spec_cons.comments }}
                                            </div>
                                        </div>
                                    </div>
                                    <!-- END SPECIAL CONSID. -->
                                </div>
                            </div>
                            <!-- PATIENT ADMINISTRATION COMPONENTS -->
                            <!-- <div style="max-height: 75vh; overflow-y: auto"> -->
                            <div style="max-height: 70vh; overflow-y: auto">

                                <!-- EXPIRED MEDICATIONS -->
                                <div style="padding: 10px;" v-if="isErxChartExpired">
                                    <div style="background-color: #E04F39; color: white; padding: 15px; border-radius: 8px; text-align: center; font-weight: bold; font-size: 1.1em; margin-bottom: 20px; border: 2px solid #c43c2a;">
                                        <i class="pi pi-exclamation-triangle" style="margin-right: 10px; font-size: 1.2em;"></i>
                                        The {{ $resident({ capitalize: true }) }}'s Digital Chart has Expired. All prescriptions on that chart have therefore expired. Please contact their prescriber to perform a chart review and renew the chart.
                                    </div>
                                </div>
                                <div class="medication-group" v-if="displayExpiredCharts && (allExpiredCharts && allExpiredCharts.length && $store.state.user?.role?.permissions?.includes('can_view_expired_charts'))">
                                    <div class="red-background medication-group-header" 
                                    style="display: flex; justify-content: space-between; padding: 10px; align-items: center; border-top-left-radius: 8px;border-top-right-radius: 8px; background-color: #7d2b1f">
                                        <h2 style="margin: 0;">Expired Medications</h2>
                                    </div>
                                    <div>
                                        <table style="border-collapse: collapse;" >
                                            <tr class="non-packed-medication-row" style="background-color: rgba(171, 58, 41, 0.3) !important" v-for="(drug, i) in allExpiredCharts" :key="i">
                                                <td v-if="mimsApiKey" style="width: 10em">
                                                    <!-- <MimsImage
                                                        :alias_id="drug.alias ? drug.alias.alias_id : ''"
                                                        off_market="true"
                                                        width="90px"
                                                        height="60px">
                                                    </MimsImage> -->
                                                </td>
                                                <td style="padding: 10px"><p style="font-size: 1em; font-weight: bold;">{{drug.alias.name.charAt(0).toUpperCase() + drug.alias.name.slice(1)}} <span class="green-button" style="margin: 3px; background-color: rgb(0, 178, 162) !important; padding: 2px 10px;" v-if="drug.type == 'prn'">PRN</span></p>
                                                <p style="font-size: 1em;"><b>Dispensed:</b> <i>{{drug.dispensed_items?.length ? drug.dispensed_items[0].name : 'No item dispensed'}}</i></p>
                                                    <p v-if="drug.indication"><b>Indication:</b> {{drug.indication}}</p>
                                                    <p style="font-size: 1em; color: #E04F39; font-weight: bold;">{{drug.instructions.split('-------Please write any additional notes below this line-------').join('')}}</p>
                                                    <p style="font-size: 1em;padding-bottom: 5px;">Previous Event: <b>{{drug.last_chart_administrations && drug.last_chart_administrations.length ?  drug.last_chart_administrations[0].administered_at  : 'N/A'}}</b></p>
                                                    <div style="display: flex; flex-wrap: wrap">
                                                        <div  v-for="(tag, tindex) in [... new Set(drug.chart_tags)]" style="margin-right: 5px" :key="tindex">
                                                            <p class="consideration-tag" style="width: fit-content" v-if="tag.toUpperCase() != 'S4' && tag.toUpperCase() != 'S8' && tag.toUpperCase() != 'S4VIC'" >{{tag.toUpperCase()}}</p>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td style="width: 5em">x {{drug.dose}}</td>
                                                <td style="width: 7em;">{{drug.route}}</td>
                                                <td style="width: 1em">
                                                    <div>
                                                        <p v-if="$store.state.user?.role?.permissions?.includes('can_action_expired_charts')" class="blue-button" style="background-color: rgb(171 58 41) !important" @click="createExpiredNote(drug), displayExpiredNoteModal=true">ACTION</p>
                                                    </div>
                                                </td>
                                                <td style="width: 1em">
                                                </td>
                                                <td v-if="redoingAdministration[drug.chart_id]?.loading" style="width: 1em">
                                                    <div ><i class="pi pi-spin pi-spinner" :id="drug.chart_id+ '-redoing'"></i></div>
                                                </td>
                                                <td v-if="drug.completed && !redoingAdministration[drug.chart_id]?.loading" @click="redoAdminChart(drug)" style="width: 1em">
                                                    <div ><i class="pi pi-replay" :id="drug.chart_id+ '-redo'"></i></div>
                                                </td>
                                                <td style="width: 0em"></td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>

                                <!-- PACKED MEDICATIONS -->
                                <div class="medication-group" v-if="getPacked.length && !patient.displayPRN && !patient.displayNIM && !patient.displayPatch && !patient.displayDailyDoses">
                                    <div class="strong-blue-background medication-group-header" 
                                    style="display: flex; justify-content: space-between; padding: 10px; align-items: center; border-top-left-radius: 8px;border-top-right-radius: 8px;">
                                        <h2 style="margin: 0;">Packed Medications <span style="margin-left: 30px">({{getIncompletePacked.length}} Medication{{getPacked.length > 1 ? 's':''}} Requiring Action)</span></h2>
                                        <div style="display: flex; align-items: center" v-if="getIncompletePacked.length">
                                            <h4 style="margin: 0;margin-left: 3.3em; color: white;">Handle All</h4>
                                            <!-- <i class="pi pi-check" style="margin-left: 2.3em" @click="packedSubmit()"></i> -->
                                            <SingleVerify style="margin-left: 2.3em" @submitIsCompleted="submitIsCompleted" :payload="submitPayload" @click="mapPackedPayload(true)"
                                                endpoint="/administer-bulk" :checkIcon="true" :loop="true" :bulkAdminister="true" buttonText="Sign All" />
                                            <i class="pi pi-times" style="margin-left: 1.4em; margin-right: 1.4em;" @click="displayDOCModal = true, mapPackedPayload(false)"></i>
                                        </div>
                                        <!-- DISABLED BUTTON DISPLAY -->
                                        <div v-else style="display: flex; align-items: center" >
                                            <h4 style="margin: 0;margin-left: 3.3em; margin-right: 15px;  color: white;">Handle All</h4>
                                            <i class="pi pi-check" style="color:lightgrey; cursor: inherit"></i>
                                            <i class="pi pi-times" style="margin-left: 1.4em; margin-right: 1.4em; color:lightgrey; cursor: inherit"></i>
                                        </div>
                                    </div>
                                    <div>
                                        <!--  -->
                                        <table style="border-collapse: collapse;" >
                                            <tr class="packed-medication-row" v-for="(drug, i) in getIncompletePacked" :key="i">
                                                <td v-if="mimsApiKey && loadMims" style="width: 10em">
                                                    <!-- <MimsImage
                                                        :alias_id="drug.dispensed_items?.length > 0 ? drug.dispensed_items[0].alias_id : drug.alias ? drug.alias.alias_id : ''"
                                                        off_market="true"
                                                        width="90px"
                                                        height="60px">
                                                    </MimsImage> -->
                                                </td>
                                                <td style="padding:10px; ">
                                                    <p style="font-weight: bold; font-size: 1em;">{{drug.alias.name.charAt(0).toUpperCase() + drug.alias.name.slice(1)}}</p>
                                                    <p v-if="expiryBool(drug.stop_date)" style="font-size: 1em;color: #E04F39;font-weight: bold"> Expiring in {{ formatExpiry(drug.stop_date) }} </p>
                                                    <p style="font-size: 1em;"><b>Dispensed:</b> <i>{{drug.dispensed_items?.length ? drug.dispensed_items[0].name : 'No item dispensed'}}</i></p>
                                                    <p v-if="drug.indication"><b>Indication:</b> {{drug.indication}}</p>
                                                    <p>{{drug.instructions.split('-------Please write any additional notes below this line-------').join('')}}</p>
                                                    <p style="font-size: 1em;padding-bottom: 5px;">Previous Event: <b>{{drug.last_chart_administrations && drug.last_chart_administrations.length ?  drug.last_chart_administrations[drug.last_chart_administrations.length - 1].administered_at  : 'N/A'}}</b></p>
                                                    <div style="display: flex; flex-wrap: wrap">
                                                        <div  v-for="(tag, tindex) in [... new Set(drug.chart_tags)]" style="margin-right: 5px" :key="tindex">
                                                            <p class="consideration-tag" style="width: fit-content; font-weight: bold;" v-if="!hiddenTags.includes(tag.toUpperCase())" >{{tag.toUpperCase()}}</p>
                                                        </div>
                                                    </div>
                                                    <p class="orange-button" style="width: fit-content" v-if="!drug.requestedSupply" @click="resupplyDrug(drug)">{{ !drug.loadingSupply ? 'REQ. RESUPPLY' : 'REQUESTING...'}}</p>
                                                    <p class="green-outline-button" style="color: #00823c; border: 2px solid #00823c" v-if="drug.requestedSupply">RESUPPLY REQUESTED</p>
                                                </td>
                                                <td style="font-weight: bold; width: 5em">x {{drug.dose}}</td>
                                                <td style="font-weight: bold; width: 7em;">{{drug.route}}</td>
                                                <td v-if="!drug.completed"  style="width: 1em">
                                                    <SingleVerify @submitIsCompleted="submitIsCompleted" :indices="i" :payload="submitPayload" @click="selectMedLoad(drug, true)"
                                                    endpoint="/administer" :status="(drug.status == 'N' || drug.status == 'R' || drug.status == 'W') ? 'danger': drug.status == 'approve'? 'good' : 'warning'" 
                                                    :warning="drug.status == 'N' ? 'Medication not available - Please notify prescriber': drug.status == 'R' ? 
                                                    ($resident({ capitalize: true }) + ' Refused - Please notify prescriber'): drug.status == 'W' ?
                                                    'Medication withheld for clinical reasons - Please notify prescriber':''" 
                                                    :dual="(drug.chart_type == 'Insulin Order' ||  drug.chart_type == 'Variable Dose') ? true: false" 
                                                    :checkIcon="true" :elemId="drug.chart_id+ '-approve'" />
                                                </td>
                                                <td v-if="!drug.completed" @click="displayDOCModal = true, selectMedLoad(drug, false)" style="width: 1em">
                                                    <div>
                                                        <i class="pi pi-times" :id="drug.chart_id+ '-reject'"></i>
                                                    </div>
                                                </td>
                                                <td v-if="drug.completed" colspan="2" style="display: table-cell; justify-content: end; align-items: center; ">
                                                    <div v-if="!drug.doc" class="administered" 
                                                        style="display: flex; justify-content: center; align-items: center; width: 6em; text-align: center; padding-right: 10px; border-radius: 6px; padding: 5px 10px;">
                                                        <!-- <i class="pi pi-check administered"></i>  -->
                                                        <p style=" text-align: center;">DONE</p>
                                                    </div>
                                                    <div v-if="drug.doc" class="not-administered" 
                                                        style=" display: flex;
                                                        align-items: center;
                                                        justify-content: center;
                                                        width: 6em;
                                                        text-align: center;
                                                        padding-right: 10px;
                                                        border-radius: 6px;
                                                        padding: 5px 10px;">
                                                        <!-- <i class="pi pi-times not-administered"></i>  -->
                                                        <p style=" text-align: center;">{{drug.doc.toUpperCase().slice(0,8)}}</p>
                                                    </div>
                                                </td>
                                                
                                                <td style="width: 0em"></td>
                                            </tr>
                                            <!-- DISPLAY INDIVIDUALLY COMPLETED PACKED MEDS BELOW THE INCOMPLETED PACKED MEDS -->
                                            <tr class="packed-medication-row" v-for="(drug, i) in getCompletePacked" :key="i">
                                                <td v-if="mimsApiKey && loadMims" style="width: 10em">
                                                    <!-- <MimsImage
                                                        :alias_id="drug.dispensed_items?.length > 0 ? drug.dispensed_items[0].alias_id : drug.alias ? drug.alias.alias_id : ''"
                                                        off_market="true"
                                                        width="90px"
                                                        height="60px">
                                                    </MimsImage> -->
                                                </td>
                                                <td style="padding:10px; ">
                                                    <p style="font-weight: bold; font-size: 1em;">{{drug.alias.name.charAt(0).toUpperCase() + drug.alias.name.slice(1)}}</p>
                                                    <p style="font-size: 1em;"><b>Dispensed:</b> <i>{{drug.dispensed_items?.length ? drug.dispensed_items[0].name : 'No item dispensed'}}</i></p>
                                                    <p v-if="drug.indication"><b>Indication:</b> {{drug.indication}}</p>
                                                    <p style="font-size: 1em;">{{drug.instructions.split('-------Please write any additional notes below this line-------').join('')}}</p>
                                                    <p style="font-size: 1em;padding-bottom: 5px;">Previous Event: <b>{{drug.last_chart_administrations && drug.last_chart_administrations.length ?  drug.last_chart_administrations[drug.last_chart_administrations.length - 1].administered_at  : 'N/A'}}</b></p>
                                                    <div style="display: flex; flex-wrap: wrap">
                                                        <div  v-for="(tag, tindex) in [... new Set(drug.chart_tags)]" style="margin-right: 5px" :key="tindex">
                                                            <p class="consideration-tag" style="width: fit-content; font-weight: bold;" v-if="!hiddenTags.includes(tag.toUpperCase())" >{{tag.toUpperCase()}}</p>
                                                        </div>
                                                    </div>
                                                    <p class="orange-button" style="width: fit-content" v-if="!drug.requestedSupply && this.$store.state.user?.role?.permissions?.includes('can_do_resupply')" @click="resupplyDrug(drug)">{{ !drug.loadingSupply ? 'REQ. RESUPPLY' : 'REQUESTING...'}}</p>
                                            <p class="green-outline-button" style="color: #00823c; border: 2px solid #00823c" v-if="drug.requestedSupply && this.$store.state.user?.role?.permissions?.includes('can_do_resupply')">RESUPPLY REQUESTED</p>
                                                </td>
                                                <td style="font-weight: bold; width: 5em">x {{drug.dose}}</td>
                                                <td style="font-weight: bold; width: 7em;">{{drug.route}}</td>
                                                <td v-if="!drug.completed"  style="width: 1em">
                                                    <SingleVerify @submitIsCompleted="submitIsCompleted" :indices="i" :payload="submitPayload" @click="selectMedLoad(drug, true)"
                                                    endpoint="/administer" :status="(drug.status == 'N' || drug.status == 'R' || drug.status == 'W') ? 'danger': drug.status == 'approve'? 'good' : 'warning'" 
                                                    :warning="drug.status == 'N' ? 'Medication not available - Please notify prescriber': drug.status == 'R' ? 
                                                    ($resident({ capitalize: true }) + ' Refused - Please notify prescriber'): drug.status == 'W' ?
                                                    'Medication withheld for clinical reasons - Please notify prescriber':''" 
                                                    :dual="(drug.chart_type == 'Insulin Order' ||  drug.chart_type == 'Variable Dose') ? true: false" 
                                                    :checkIcon="true" :elemId="drug.chart_id+ '-approve'" />
                                                </td>
                                                <td v-if="!drug.completed" @click="displayDOCModal = true, selectMedLoad(drug, false)" style="width: 1em">
                                                    <div ><i class="pi pi-times" :id="drug.chart_id+ '-reject'"></i></div>
                                                </td>
                                                <td v-if="drug.completed && !redoingAdministration[drug.chart_id]?.loading" colspan="2" style="justify-content: end; align-items: center; margin-top: 33px; display: flex; flex-direction: column;">
                                                    <div v-if="!drug.doc" class="administered" 
                                                        style="display: flex; justify-content: center; align-items: center; width: 6em; text-align: center; padding-right: 10px; border-radius: 6px; padding: 5px 10px;">
                                                        <!-- <i class="pi pi-check administered"></i>  -->
                                                        <p style=" text-align: center;">DONE</p>
                                                    </div>
                                                    <div v-if="drug.doc" class="not-administered" 
                                                        style="display: flex; align-items: center; justify-content: center; width: 6em; text-align: center; padding-right: 10px; border-radius: 6px; padding: 5px 10px;">
                                                        <!-- <i class="pi pi-times not-administered"></i>  -->
                                                        <p style=" text-align: center;">{{drug.doc.toUpperCase().slice(0,8)}}</p>
                                                    </div>
                                                    <!-- Error message if a redoingAdminChart action goes wrong. Check console for error details -->
                                                    <div v-if="redoingAdministration[drug.chart_id]?.error" style="color: red; font-size: 15px;">Error: Redo Failed.</div>
                                                </td>
                                                <td v-if="redoingAdministration[drug.chart_id]?.loading" style="width: 1em">
                                                    <div ><i class="pi pi-spin pi-spinner" :id="drug.chart_id+ '-redoing'"></i></div>
                                                </td>
                                                <td v-if="drug.completed && !redoingAdministration[drug.chart_id]?.loading" @click="redoAdminChart(drug)" style="width: 1em">
                                                    <div ><i class="pi pi-replay" :id="drug.chart_id+ '-redo'"></i></div>
                                                </td>
                                                <td style="width: 0em"></td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>

                                <!-- S8/S4D MEDICATIONS -->
                                <div class="medication-group" v-if="getS8.length && !patient.displayPRN && !patient.displayNIM && !patient.displayPatch && !patient.displayDailyDoses">
                                    <div class="red-background medication-group-header" 
                                    style="display: flex; justify-content: space-between; padding: 10px; align-items: center; border-top-left-radius: 8px;border-top-right-radius: 8px;">
                                        <h2 style="margin: 0;">Drug Register Medications <span style="margin-left: 30px">({{getIncompleteS8.length}} Medication{{getIncompleteS8.length > 1 ? 's':''}} Requiring Action)</span></h2>
                                    </div>
                                    <div>
                                        <table style="border-collapse: collapse;"  >
                                            <tr class="scheduled-medication-row" v-for="(drug, i) in getS8" :key="i">
                                                <td v-if="mimsApiKey && loadMims" style="width: 10em">
                                                    <!-- <MimsImage
                                                       :alias_id="drug.dispensed_items?.length > 0 ? drug.dispensed_items[0].alias_id : drug.alias ? drug.alias.alias_id : ''"
                                                        off_market="true"
                                                        width="90px"
                                                        height="60px">
                                                    </MimsImage> -->
                                                </td>
                                                <td style="padding:10px;">
                                                    <p style="font-size: 1em; font-weight: bold;">{{drug.alias.name.charAt(0).toUpperCase() + drug.alias.name.slice(1)}} <i>({{drug.stock_items && drug.stock_items.length ? 'Stock may be available' : 'No stock available'}})</i></p>
                                                    <p v-if="expiryBool(drug.stop_date)" style="font-size: 1em;color: #E04F39;font-weight: bold"> Expiring in {{ formatExpiry(drug.stop_date) }} </p>
                                                    <p style="font-size: 1em;"><b>Dispensed:</b> <i>{{drug.dispensed_items?.length ? drug.dispensed_items[0].name : 'No item dispensed'}}</i></p>
                                                    <p v-if="drug.indication"><b>Indication:</b> {{drug.indication}}</p>
                                                    <p>{{drug.instructions.split('-------Please write any additional notes below this line-------').join('')}}</p>
                                                    <p style="font-size: 1em;padding-bottom: 5px;">Previous Event: <b>{{drug.last_chart_administrations && drug.last_chart_administrations.length ?  drug.last_chart_administrations[drug.last_chart_administrations.length - 1].administered_at  : 'N/A'}}</b></p>
                                                    
                                                    <div style="display: flex; flex-wrap: wrap">
                                                        <div  v-for="(tag, tindex) in [... new Set(drug.chart_tags)]" style="margin-right: 5px" :key="tindex">
                                                            <p class="consideration-tag" style="width: fit-content" v-if="!hiddenTags.includes(tag.toUpperCase())">{{tag.toUpperCase()}}</p>
                                                        </div>
                                                    </div>
                                                    <p class="orange-button" style="width: fit-content" v-if="!drug.requestedSupply && this.$store.state.user?.role?.permissions?.includes('can_do_resupply')" @click="resupplyDrug(drug)">{{ !drug.loadingSupply ? 'REQ. RESUPPLY' : 'REQUESTING...'}}</p>
                                            <p class="green-outline-button" style="color: #00823c; border: 2px solid #00823c" v-if="drug.requestedSupply && this.$store.state.user?.role?.permissions?.includes('can_do_resupply')">RESUPPLY REQUESTED</p>
                                                </td>
                                                <td style="font-weight:bold; width: 5em">x {{drug.dose}}</td>
                                                <td style="font-weight:bold; ;" :style="drug.completed ? {width: '5em'}:{width: '10em'}">{{drug.route}}</td>
                                                <td v-if="!drug.completed && drug.removed && drug.sliding_scale && drug.sliding_scale.length" @click="displaySlidingScaleModal = true, selectSlidingScaleDrug(drug)" style="width: 1em">
                                                    <div class="administer-button" style="width: 100px; padding: 5px;">GET READING</div>
                                                </td>
                                                <td v-else-if="!drug.completed && drug.removed"  style="width: 1em">
                                                    <SingleVerify v-if="drug.dose_unit!='Patch' && drug.dose_unit!='patch'" @submitIsCompleted="submitIsCompleted" :indices="i" :payload="submitPayload" @click="selectMedLoad(drug, true)"
                                                    endpoint="/administer" :status="(drug.status == 'N' || drug.status == 'R' || drug.status == 'W') ? 'danger': drug.status == 'approve'? 'good' : 'warning'" 
                                                    :warning="drug.status == 'N' ? 'Medication not available - Please notify prescriber': drug.status == 'R' ? 
                                                    ($resident({ capitalize: true }) + ' Refused - Please notify prescriber'): drug.status == 'W' ?
                                                    'Medication withheld for clinical reasons - Please notify prescriber':''" 
                                                    :dual="true" :checkIcon="true" :elemId="drug.chart_id+ '-approve'" />
                                                    <div v-else><i class="pi pi-check" :id="drug.chart_id+ '-approve'" @click="displayPatchAdminModal = true, selectMedLoad(drug, true), selectedPatch = drug"></i></div>
                                                </td>
                                                <td v-if="!drug.removed && !drug.completed" @click="()=>{removeDrugFromRegister(drug)}"  style="width: 1em">
                                                    <!-- <div ><i v-tooltip="'Select to remove from safe'" class="pi pi-eject" :style="drug.selectedForRemoval ? {backgroundColor: '#00AD50', color: 'white'}:{}"></i></div> -->
                                                    <SingleVerify
                                                        v-if="drug.stock_items && drug.stock_items.length"
                                                        @getDrugId="getDrugId"
                                                        :stock_items="drug.stock_items"
                                                        :payload="removeFromRegisterPayload" 
                                                        endpoint="/drug-safe-retrieval"
                                                        :drugSafeRemoval="true"
                                                        :dual="true"
                                                        :notes="true"
                                                        :id="drug.uuid"
                                                        :discardAvailable="discardAvailable"
                                                    />
                                                </td>
                                                <td v-if="!drug.completed && (!drug.sliding_scale || !drug.sliding_scale.length)" @click="displayDOCModal = true, selectMedLoad(drug, false)" style="width: 1em">
                                                    <div ><i class="pi pi-times" :id="drug.chart_id+ '-reject'"></i></div>
                                                </td>
                                                <td v-else-if="!drug.completed && drug.sliding_scale && drug.sliding_scale.length">
                                                    <div @click="displayDOCModal = true, selectMedLoad(drug, false)">
                                                        <i class="pi pi-times" :id="drug.chart_id+ '-reject'"></i>
                                                    </div>
                                                </td>
                                                
                                                <td v-if="(drug.completed || drug.doc) && !redoingAdministration[drug.chart_id]?.loading" colspan="2" style="display: flex; flex-direction: column; justify-content: end; align-items: center; margin-top: 7px;">
                                                    <div v-if="!drug.doc" class="administered" 
                                                        style=" display: flex;
                                                        align-items: center;
                                                        justify-content: center;
                                                        width: 6em;
                                                        text-align: center;
                                                        padding-right: 10px;
                                                        border-radius: 6px;">
                                                        <!-- <i class="pi pi-check administered"></i>  -->
                                                        <p style="padding: 5px 10px; text-align: center;">DONE</p>
                                                    </div>
                                                    <div v-if="drug.doc && !redoingAdministration[drug.chart_id]?.loading" class="not-administered" 
                                                        style=" display: flex;
                                                        align-items: center;
                                                        justify-content: center;
                                                        width: 6em;
                                                        text-align: center;
                                                        padding-right: 10px;
                                                        border-radius: 6px;
                                                        padding: 5px 10px;">
                                                        <!-- <i class="pi pi-times not-administered"></i>  -->
                                                        <p style=" text-align: center; white-space: nowrap">{{drug.doc.toUpperCase().slice(0,8)}}</p>
                                                    </div>
                                                    <!-- Error message if a redoingAdminChart action goes wrong. Check console for error details -->
                                                    <div v-if="redoingAdministration[drug.chart_id]?.error" style="color: red; font-size: 15px;">Error: Redo Failed.</div>
                                                </td>
                                                <td v-if="redoingAdministration[drug.chart_id]?.loading" style="width: 1em">
                                                    <div ><i class="pi pi-spin pi-spinner" :id="drug.chart_id+ '-redoing'"></i></div>
                                                </td>
                                                <td v-if="drug.doc && !drug.removed && !redoingAdministration[drug.chart_id]?.loading" @click="redoAdminChart(drug)" style="width: 1em">
                                                    <div>
                                                        <i class="pi pi-replay" :id="drug.chart_id+ '-redo'"></i>
                                                    </div>
                                                </td>
                                                <td style="width: 0em"></td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>

                                <!-- INSULIN MEDICATIONS -->
                                <div class="medication-group" v-if="getInsulin.length && !patient.displayPRN && !patient.displayNIM && !patient.displayPatch && !patient.displayDailyDoses">
                                    <div class="yellow-background medication-group-header" 
                                    style="display: flex; justify-content: space-between; padding: 10px; align-items: center; border-top-left-radius: 8px;border-top-right-radius: 8px;">
                                        <h2 style="margin: 0;">Insulin Medications <span style="margin-left: 30px">({{getIncompleteInsulin.length}} Medication{{getIncompleteInsulin.length > 1 ? 's':''}} Requiring Action)</span></h2>
                                        <span class="tag" style="justify-self:end; width: auto;font-weight: 700; font-size: 15px; border-left: 40%;">
                                        <p style="color:#2c3e50;font-weight: 16px;padding: 0 0; margin: 0 0;" >Last BGL reading: {{patient.readings?.length ? patient.readings[0].value + " mmols/L at " +patient.readings[0].created_at : "N/A"}}</p>
                                        </span>
                                    </div>
                                    <div>
                                        <table style="border-collapse: collapse;"  >
                                            <tr class="insulin-medication-row" v-for="(drug, i) in getInsulin" :key="i">
                                                <td style="width: 10em"><div class="drug-image"><img src="../../assets/icons/medPlaceholder.png" alt=""></div></td>
                                                <td style="padding:10px;">
                                                    <p style="font-size: 1em; font-weight: bold;">{{drug.alias.name.charAt(0).toUpperCase() + drug.alias.name.slice(1)}}</p>                                                     
                                                    <p v-if="expiryBool(drug.stop_date)" style="font-size: 1em;color: #E04F39;font-weight: bold"> Expiring in {{ formatExpiry(drug.stop_date) }} </p>
                                                    <p style="font-size: 1em;"><b>Dispensed:</b> <i>{{drug.dispensed_items?.length ? drug.dispensed_items[0].name : 'No item dispensed'}}</i></p>
                                                    <p v-if="drug.indication"><b>Indication:</b> {{drug.indication}}</p>
                                                    <p>{{drug.instructions.split('-------Please write any additional notes below this line-------').join('')}}</p>
                                                            <p style="font-size: 1em;padding-bottom: 5px;">Previous Event: <b>{{drug.last_chart_administrations && drug.last_chart_administrations.length ?  drug.last_chart_administrations[drug.last_chart_administrations.length - 1].administered_at  : 'N/A'}}</b></p>
                                                    <div style="display: flex; flex-wrap: wrap">
                                                        <div  v-for="(tag, tindex) in [... new Set(drug.chart_tags)]" style="margin-right: 5px" :key="tindex">
                                                            <p class="consideration-tag" style="width: fit-content" v-if="!hiddenTags.includes(tag.toUpperCase())">{{tag.toUpperCase()}}</p>
                                                        </div>
                                                    </div>
                                                    <p class="orange-button" style="width: fit-content" v-if="!drug.requestedSupply && this.$store.state.user?.role?.permissions?.includes('can_do_resupply')" @click="resupplyDrug(drug)">{{ !drug.loadingSupply ? 'REQ. RESUPPLY' : 'REQUESTING...'}}</p>
                                            <p class="green-outline-button" style="color: #00823c; border: 2px solid #00823c" v-if="drug.requestedSupply && this.$store.state.user?.role?.permissions?.includes('can_do_resupply')">RESUPPLY REQUESTED</p>
                                                </td>
                                                <td style="font-weight:bold; width: 5em">x {{drug.dose}}</td>
                                                <td style="font-weight:bold; ;" :style="drug.completed ? {width: '5em'}:{width: '10em'}">{{drug.route}}</td>
                                                <td v-if="(getIncompleteInsulin.length != getInsulin.length) && !drug.completed"></td>
                                                <!-- <td @click="displayInsulinModal = true, selectInsulin(drug)"  style="width: 1em" v-if="(!lastBGLReading || lastBGLReading > 60) && !drug.completed">
                                                    <div class="administer-button">GET BGL</div>
                                                </td> -->

                                                <!-- ADMIN AND CROSS -->
                                                <td @click="displayInsulinModal = true, selectInsulin(drug)"  style="width: 1em;" v-if="!drug.completed">
                                                    <i class="pi pi-check"></i>
                                                </td>
                                                <td  v-if="!drug.completed" @click="displayDOCModal = true, selectMedLoad(drug, false)"  style="width: 1em">
                                                    <div>
                                                        <i class="pi pi-times" :id="drug.chart_id+ '-reject'"></i>
                                                    </div>
                                                </td>
                                                
                                                <td v-if="drug.completed && !redoingAdministration[drug.chart_id]?.loading" colspan="2" style="display: flex; flex-direction: column;" >
                                                    <div 
                                                        v-if="!drug.doc"
                                                        class="administered" 
                                                        style=" display: flex;
                                                        align-items: center;
                                                        justify-content: center;
                                                        width: 6em;
                                                        text-align: center;
                                                        padding-right: 10px;
                                                        border-radius: 6px;">
                                                        <p style="padding: 5px 10px; text-align: center;">DONE</p>
                                                    </div>
                                                    <div
                                                        v-if="drug.doc && !redoingAdministration[drug.chart_id]?.loading"
                                                        class="not-administered" 
                                                        style="display: flex; align-items: center; width: 6em; text-align: center; padding-right: 10px; justify-content: center; border-radius: 6px; padding: 5px 10px;">
                                                        <!-- <i class="pi pi-times not-administered"></i>  -->
                                                        <p style=" text-align: center;">{{drug.doc.toUpperCase().slice(0,8)}}</p>
                                                    </div>
                                                    <!-- Error message if a redoingAdminChart action goes wrong. Check console for error details -->
                                                    <div v-if="redoingAdministration[drug.chart_id]?.error" style="color: red; font-size: 15px;">Error: Redo Failed.</div>
                                                </td>
                                                <td v-if="redoingAdministration[drug.chart_id]?.loading" style="width: 1em">
                                                    <div ><i class="pi pi-spin pi-spinner" :id="drug.chart_id+ '-redoing'"></i></div>
                                                </td>
                                                <td v-if="drug.completed && !redoingAdministration[drug.chart_id]?.loading" @click="redoAdminChart(drug)" style="width: 1em">
                                                    <div ><i class="pi pi-replay" :id="drug.chart_id+ '-redo'"></i></div>
                                                </td>
                                                
                                                <td style="width: 0em"></td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>

                                <!-- NON PACKED MEDICATIONS -->
                                <div class="medication-group" v-if="getNonPacked.length && !patient.displayPRN && !patient.displayNIM && !patient.displayPatch && !patient.displayDailyDoses">
                                    <div class="dark-grey-background medication-group-header" 
                                    style="display: flex; justify-content: space-between; padding: 10px; align-items: center; border-top-left-radius: 8px;border-top-right-radius: 8px;">
                                        <h2 style="margin: 0;">Non-Packed Medications <span style="margin-left: 30px">({{getIncompleteNonPacked.length}} Medication{{getIncompleteNonPacked.length > 1 ? 's':''}} Requiring Action)</span></h2>
                                        <div style="display: flex; align-items: center" v-if="getIncompleteNonPacked.length">
                                            <h4 style="margin: 0;margin-left: 3.3em; color: white;">Handle All</h4>
                                            <!-- <i class="pi pi-check" style="margin-left: 2.3em" @click="packedSubmit()"></i> -->
                                            <SingleVerify style="margin-left: 2.3em" @submitIsCompleted="submitIsCompleted" :payload="submitPayload" @click="mapNonpackedPayload(true)"
                                                endpoint="/administer-bulk" :checkIcon="true" :loop="true" :bulkAdminister="true" buttonText="Sign All" />
                                            <i class="pi pi-times" style="margin-left: 1.4em; margin-right: 1.4em;" @click="displayDOCModal = true, mapNonpackedPayload(false)"></i>
                                        </div>
                                    </div>
                                    <div>
                                        <table style="border-collapse: collapse;"  >
                                            <tr class="non-packed-medication-row" v-for="(drug, i) in getNonPacked" :key="i">
                                                <td v-if="mimsApiKey && loadMims" style="width: 10em">
                                                    <!-- <MimsImage
                                                        :alias_id="drug.dispensed_items?.length > 0 ? drug.dispensed_items[0].alias_id : drug.alias ? drug.alias.alias_id : ''"
                                                        off_market="true"
                                                        width="90px"
                                                        height="60px">
                                                    </MimsImage> -->
                                                </td>
                                                <td>
                                                    <!-- paracetamol 1 g powder for oral liquid, 1 sachet -->
                                                    <p style="font-size: 1em; font-weight: bold;">{{drug.alias.name.charAt(0).toUpperCase() + drug.alias.name.slice(1)}}</p>
                                                    <p v-if="expiryBool(drug.stop_date)" style="font-size: 1em;color: #E04F39;font-weight: bold"> Expiring in {{ formatExpiry(drug.stop_date) }} </p>
                                                    <p style="font-size: 1em;"><b>Dispensed:</b> <i>{{drug.dispensed_items?.length ? drug.dispensed_items[0].name : 'No item dispensed'}}</i></p>
                                                    <p v-if="drug.indication"><b>Indication:</b> {{drug.indication}}</p>
                                                    <p style="font-size: 1em">{{drug.instructions.split('-------Please write any additional notes below this line-------').join('')}}</p>
                                                            <p style="font-size: 1em;padding-bottom: 5px;">Previous Event: <b>{{drug.last_chart_administrations && drug.last_chart_administrations.length ?  drug.last_chart_administrations[drug.last_chart_administrations.length - 1].administered_at  : 'N/A'}}</b></p>
                                                    <div style="display: flex; flex-wrap: wrap">
                                                        <div v-for="(tag, tindex) in [... new Set(drug.chart_tags)]" style="margin-right: 5px" :key="tindex">
                                                            <p class="consideration-tag" style="width: fit-content" v-if="!hiddenTags.includes(tag.toUpperCase())" >{{tag.toUpperCase()}}</p>
                                                        </div>
                                                    </div>
                                                    <p class="orange-button" style="width: fit-content" v-if="!drug.requestedSupply && this.$store.state.user?.role?.permissions?.includes('can_do_resupply')" @click="resupplyDrug(drug)">{{ !drug.loadingSupply ? 'REQ. RESUPPLY' : 'REQUESTING...'}}</p>
                                            <p class="green-outline-button" style="color: #00823c; border: 2px solid #00823c" v-if="drug.requestedSupply && this.$store.state.user?.role?.permissions?.includes('can_do_resupply')">RESUPPLY REQUESTED</p>
                                                </td>
                                                <td style="width: 5em; font-weight: bold">x {{drug.dose}}</td>
                                                <td style="width: 7em; font-weight: bold">{{drug.route}}</td>
                                                <td v-if="(getIncompletePacked.length != getNonPacked.length) && !drug.completed"></td>
                                                <td v-if="!drug.completed && drug.sliding_scale && drug.sliding_scale.length" @click="displaySlidingScaleModal = true, selectSlidingScaleDrug(drug)" style="width: 1em">
                                                    <div class="administer-button" style="width: 100px; padding: 5px;">GET READING</div>
                                                </td>
                                                <td v-else-if="!drug.completed" style="width: 1em">
                                                    
                                                    <SingleVerify v-if="drug.dose_unit != 'Patch' && drug.dose_unit != 'patch'" @submitIsCompleted="submitIsCompleted" :indices="i" :payload="submitPayload" @click="selectMedLoad(drug, true)"
                                                    endpoint="/administer" 
                                                    :dual="(drug.chart_type == 'Insulin Order' ||  drug.chart_type == 'Variable Dose') ? true: false" 
                                                    :checkIcon="true" :elemId="drug.chart_id+ '-approve'" />
                                                    <div v-else><i class="pi pi-check" :id="drug.chart_id+ '-approve'" @click="displayPatchAdminModal = true, selectMedLoad(drug, true), selectedPatch = drug"></i></div>
                                                    
                                                </td>
                                                <td v-if="!drug.completed && (!drug.sliding_scale || !drug.sliding_scale.length)" @click="displayDOCModal = true, selectMedLoad(drug, false)"  style="width: 1em">
                                                    <div>
                                                        <i class="pi pi-times" :id="drug.chart_id+ '-reject'"></i>
                                                    </div>
                                                </td>
                                                <td v-else-if="!drug.completed && drug.sliding_scale && drug.sliding_scale.length">
                                                    <!-- Cross button is skipped for sliding scale right now as it's handled via the modal typically, or just allow it: -->
                                                    <div @click="displayDOCModal = true, selectMedLoad(drug, false)">
                                                        <i class="pi pi-times" :id="drug.chart_id+ '-reject'"></i>
                                                    </div>
                                                </td>
                                                
                                                <td v-if="drug.completed && !redoingAdministration[drug.chart_id]?.loading" colspan="2" style="display: flex; flex-direction: column;">
                                                    <div
                                                        v-if="!drug.doc"
                                                        class="administered"
                                                        style="display: flex; align-items: center; width: 6em; text-align: center; padding-right: 10px; justify-content: center; border-radius: 6px;">
                                                        <!-- <i class="pi pi-check administered"></i>  -->
                                                        <p style="padding: 5px 10px; text-align: center;">DONE</p>
                                                    </div>
                                                    <div
                                                        v-if="drug.doc"
                                                        class="not-administered" 
                                                        style="display: flex; align-items: center; width: 6em; text-align: center; padding-right: 10px; justify-content: center; border-radius: 6px; padding: 5px 10px;">
                                                        <!-- <i class="pi pi-times not-administered"></i>  -->
                                                        <p style=" text-align: center;">{{drug.doc.toUpperCase().slice(0,8)}}</p>
                                                    </div>
                                                    <!-- Error message if a redoingAdminChart action goes wrong. Check console for error details -->
                                                    <div v-if="redoingAdministration[drug.chart_id]?.error" style="color: red; font-size: 15px;">Error: Redo Failed.</div>
                                                </td>
                                                <td v-if="redoingAdministration[drug.chart_id]?.loading" style="width: 1em">
                                                    <div ><i class="pi pi-spin pi-spinner" :id="drug.chart_id+ '-redoing'"></i></div>
                                                </td>
                                                <td v-if="drug.completed && !redoingAdministration[drug.chart_id]?.loading" @click="redoAdminChart(drug)" style="width: 1em">
                                                    <div ><i class="pi pi-replay" :id="drug.chart_id+ '-redo'"></i></div>
                                                </td>
                                                <td style="width: 0em"></td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>



                                <!-- PRN MEDICATIONS -->
                                <div class="medication-group" v-if="patient.displayPRN">
                                    <div v-if="!loadingPRNs">
                                        <div v-for="(drug, i) in prns" :key="i" style="margin-bottom: 1em;">
                                            <div class="medication-group-header"  
                                            style="display: grid; grid-template-columns:30% 70%; align-items:center; background-color: rgb(0, 178, 162); padding: 10px 30px; align-items: center; border-top-left-radius: 8px;border-top-right-radius: 8px;">
                                                <h2 style="margin: 0;">PRN</h2>
                                                <span class="tag" style="justify-self:end; width: auto;font-weight: 700; font-size: 15px; border-left: 40%;">
                                                    <span v-if="drug.amount_administered==drug.max_dose"><p style="color:#E04F39;font-weight: 16px;padding: 0 0; margin: 0 0;"> {{parseFloat(drug.amount_administered)}}/{{drug.max_dose ? drug.max_dose : 'null'}} {{drug.dose_unit}}{{ drug.max_dose && drug.max_dose > 1 ? 's' : ''}} administered in the last 24 hours</p></span>
                                                    <span style="color: #2c3e50;font-weight: 16px;" v-else><p style="font-weight: 16px;padding: 0 0; margin: 0 0;">{{parseFloat(drug.amount_administered)}}/{{drug.max_dose ? drug.max_dose : 'null'}} {{drug.dose_unit}}{{ drug.max_dose && drug.max_dose > 1 ? 's' : ''}} administered in the last 24 hours</p></span>
                                                </span>
                                            </div>
                                            <div v-if="drug.completed  && (drug.effective != true) && (drug.effective != false)" style="display: flex; justify-content: space-between; background-color: #E04F39; height: 45px; padding: 0 30px; align-items: center;">
                                                <p style="font-size: 16px; font-weight: bold;">{{drug.last_chart_administrations && drug.last_chart_administrations.length ? drug.last_chart_administrations[0].quantity : 'N/A'}} {{drug.dose_unit}}/s was administered at {{drug.last_chart_administrations && drug.last_chart_administrations.length ? drug.last_chart_administrations[0].administered_at : ''}}. Was this effective?</p>

                                                <span style="display: grid; grid-gap: 10px; grid-template-columns: 1fr 1fr">
                                                    <div ><i class="pi pi-check" @click="addEffective(1, drug)"></i></div>
                                                    <div ><i class="pi pi-times" @click="addEffective(0, drug)" ></i></div>
                                                </span>
                                            </div>
                                            <div>
                                                <table style="border-collapse: collapse;" >
                                                    <tr class="prn-medication-row">
                                                        <td v-if="mimsApiKey && loadMims" style="width: 10em">
                                                            <!-- <MimsImage
                                                                :alias_id="drug.dispensed_items?.length > 0 ? drug.dispensed_items[0].alias_id : drug.alias ? drug.alias.alias_id : ''"
                                                                off_market="true"
                                                                width="90px"
                                                                height="60px">
                                                            </MimsImage> -->
                                                        </td>
                                                        <td style="padding:10px"><p style="font-size: 1em; font-weight: bold;">{{drug.alias.name.charAt(0).toUpperCase() + drug.alias.name.slice(1)}}</p>
                                                            <p v-if="expiryBool(drug.stop_date)" style="font-size: 1em;color: #E04F39;font-weight: bold"> Expiring in {{ formatExpiry(drug.stop_date) }} </p>
                                                            <p style="font-size: 1em;"><b>Dispensed:</b> <i>{{drug.dispensed_items?.length ? drug.dispensed_items[0].name : 'No item dispensed'}}</i></p>
                                                            <p v-if="drug.indication"><b>Indication:</b> {{drug.indication}}</p>
                                                            <p>{{drug.instructions.split('-------Please write any additional notes below this line-------').join('')}}</p>
                                                            <p style="font-size: 1em;padding-bottom: 5px;">Previous Event: <b>{{drug.last_chart_administrations && drug.last_chart_administrations.length ?  drug.last_chart_administrations[drug.last_chart_administrations.length - 1].administered_at  : 'N/A'}}</b></p>
                                                            <div style="display: flex; flex-wrap: wrap">
                                                                <div  v-for="(tag, tindex) in [... new Set(drug.chart_tags)]" style="margin-right: 5px" :key="tindex">
                                                                    <p class="consideration-tag" style="width: fit-content" v-if="!hiddenTags.includes(tag.toUpperCase())" >{{tag.toUpperCase()}}</p>
                                                                </div>
                                                            </div>
                                                            <p class="orange-button" style="width: fit-content" v-if="!drug.requestedSupply && this.$store.state.user?.role?.permissions?.includes('can_do_resupply')" @click="resupplyDrug(drug)">{{ !drug.loadingSupply ? 'REQ. RESUPPLY' : 'REQUESTING...'}}</p>
                                                            <p class="green-outline-button" style="color: #00823c; border: 2px solid #00823c" v-if="drug.requestedSupply && this.$store.state.user?.role?.permissions?.includes('can_do_resupply')">RESUPPLY REQUESTED</p>
                                                        </td>
                                                        <td style="width: 5em; font-weight: bold;">x {{drug.dose}}</td>
                                                        <td style="width: 10em; font-weight: bold;">{{drug.route}}</td>
                                                        <!-- @click="submitPrimeSignature(drug, 'approve')"  -->
                                                        <td style="width: 1em"></td>
                                                            <!-- <div ><i class="pi pi-check" :id="drug.chart_id+ '-approve'"></i></div> -->
                                                        <td   style="width: 1em" v-if="((drug.alias.tags.includes('S8') || drug.alias.tags.includes('s8')) || drug.stock_items?.length) && !drug.removed && !drug.completed">
                                                            <!-- <div class="administer-button">REMOVE FROM REG</div> -->
                                                            <div @click="displayPRNAdminModal = true, selectPRN(drug)" class="administer-button" v-if="(drug.stock_items?.length && drug.stock_items[0].quantity > 0)">REMOVE FROM REG</div>
                                                            <div class="administer-button" style="cursor: inherit; color: red" v-else>NO STOCK</div>
                                                        </td>
                                                        <td @click="displayPRNAdminModal = true, selectPRN(drug)"  style="width: 1em" v-if="((!drug.alias.tags.includes('S8') && !drug.alias.tags.includes('s8')) && (!drug.stock_items?.length || drug.removed)) && !drug.completed">
                                                            <div class="administer-button">ADMINISTER</div>
                                                        </td>
                                                        <td  style="width: 1em" v-if="drug.completed">
                                                            <div class="administer-button" style="cursor: inherit">COMPLETED</div>
                                                        </td>
                                                        <td style="width: 0em"></td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- NIM MEDICATIONS -->
                                <div class="medication-group" v-if="patient.displayNIM">
                                    <div v-if="!loadingNIMs">
                                        <div v-for="(drug, i) in nims" :key="i" style="margin-bottom: 1em;">
                                            <div class="medication-group-header"  
                                            style="display: flex; justify-content: flex-start; background-color: #274188; padding: 10px 30px; align-items: center; border-top-left-radius: 8px;border-top-right-radius: 8px;">
                                                <h2 style="margin: 0;">NIM</h2>
                                                <span style=" font-weight: 700;
                                                font-size: 18px;
                                                line-height: 22px;
                                                margin-left: 15em;
                                                color: white;">{{parseFloat(drug.amount_administered).toFixed(2)}}/{{drug.max_dose ? drug.max_dose : 'null'}} {{drug.alias.form}}{{ drug.max_dose && drug.max_dose > 1 ? 's' : ''}} administered in the last 24 hours</span>
                                            </div>
                                            <div>
                                                <table style="border-collapse: collapse;" >
                                                    <tr class="nim-medication-row">
                                                        <td style="width: 10em"><div class="drug-image"><img src="../../assets/icons/medPlaceholder.png" alt=""></div></td>
                                                        <td style="padding:10px">
                                                            <p style="font-size: 1em; font-weight: bold;">{{drug.alias.name.charAt(0).toUpperCase() + drug.alias.name.slice(1)}}</p>
                                                            <p style="font-size: 1em;"><b>Dispensed:</b> <i>{{drug.dispensed_items?.length ? drug.dispensed_items[0].name : 'No item dispensed'}}</i></p>
                                                            <p>{{drug.indication}}</p>
                                                            <p>{{drug.instructions}}</p>
                                                        </td>
                                                        <td style="width: 5em; font-weight: bold;">x {{drug.dose}}</td>
                                                        <td style="width: 10em; font-weight: bold;">{{drug.route}}</td>
                                                        <td style="width: 1em"></td>
                                                        <td @click="displayNIMAdminModal = true, selectNIM(drug)" v-if="!drug.completed" style="width: 1em" >
                                                            <div class="administer-button">ADMINISTER</div>
                                                        </td>
                                                        <td  style="width: 1em" v-if="drug.completed">
                                                            <div class="administer-button" style="cursor: inherit">COMPLETED</div>
                                                        </td>
                                                        <td style="width: 0em"></td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- DAILY DOSES MEDICATIONS -->
                                <div class="medication-group" v-if="patient.displayDailyDoses">
                                    <div v-if="!loadingDailyDoses">
                                        <div class="medication-group-header"  
                                            style="display: flex; justify-content: flex-start; background-color: #274188; padding: 10px 30px; align-items: center; border-top-left-radius: 8px;border-top-right-radius: 8px;">
                                            <h2 style="margin: 0; color: white;">Daily Doses</h2>
                                        </div>
                                        <div>
                                            <table style="border-collapse: collapse; width: 100%;">
                                                <thead>
                                                    <tr style="background-color: #f3f4f4;">
                                                        <th style="padding: 10px; text-align: left; border-bottom: 1px solid #ddd;">Medication</th>
                                                        <th style="padding: 10px; text-align: left; border-bottom: 1px solid #ddd;">Time</th>
                                                        <th style="padding: 10px; text-align: left; border-bottom: 1px solid #ddd;">Dose</th>
                                                        <th style="padding: 10px; text-align: left; border-bottom: 1px solid #ddd;">Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(drug, i) in dailyDoses" :key="i" style="border-bottom: 1px solid #ddd;">
                                                        <td style="padding: 10px; text-align: left;">{{ drug.alias?.name }}</td>
                                                        <td style="padding: 10px; text-align: left;">{{ drug.custom_fields?.time }}</td>
                                                        <td style="padding: 10px; text-align: left;">{{ drug.custom_fields?.dose }}</td>
                                                        <td style="padding: 10px; text-align: left;">
                                                            <span style="margin-right: 5px" v-if="drug.prescription && drug.prescription.deleted_at" class="s8-tag">Ceased at {{ drug.prescription.deleted_at?.slice(0,-7) || drug.prescription.deleted_at }}</span>
                                                            <span style="margin-right: 5px" v-else-if="drug.prescription && isMedicationExpired(drug.prescription)" class="orange-tag">Expired at {{ drug.prescription.stop_date?.slice(0,-7) || drug.prescription.stop_date }}</span>
                                                            <span style="margin-right: 5px" v-else-if="drug.prescription && !isMedicationExpired(drug.prescription)" class="green-tag">Active</span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <div v-if="loadingPRNs && patient.displayPRN">
                                        <i class="pi pi-spin pi-spinner" style="font-size: 2rem !important;margin-top: 2em;"></i>
                                        <h4>Loading PRNs...</h4>
                                    </div>
                                    <div v-if="loadingNIMs && patient.displayNIM">
                                        <i class="pi pi-spin pi-spinner" style="font-size: 2rem !important;margin-top: 2em;"></i>
                                        <h4>Loading NIMs...</h4>
                                    </div>
                                    <div v-if="loadingDailyDoses && patient.displayDailyDoses">
                                        <i class="pi pi-spin pi-spinner" style="font-size: 2rem !important;margin-top: 2em;"></i>
                                        <h4>Loading Daily Doses...</h4>
                                    </div>
                                    <div v-if="(prns && !prns.length) && !loadingPRNs && patient.displayPRN">
                                        <h3>No PRNs available for this {{ $resident() }}.</h3>
                                    </div>
                                    <div v-if="(nims && !nims.length) && !loadingNIMs && patient.displayNIM">
                                        <h3>No NIMs available for this {{ $resident() }}.</h3>
                                    </div>
                                    <div v-if="(dailyDoses && !dailyDoses.length) && !loadingDailyDoses && patient.displayDailyDoses">
                                        <h3>No Daily Doses available for this {{ $resident() }}.</h3>
                                    </div>
                                </div>

                                <!-- PATCH MEDICATION -->
                                <div class="medication-group" v-if="patient.displayPatch">
                                    <div>
                                        <div v-for="(drug, i) in patches" :key="i" style="margin-bottom: 1em;">
                                            <div class="medication-group-header"  
                                            style="display: flex; justify-content: flex-start; background-color: #EF9600; padding: 10px 30px; align-items: center; border-top-left-radius: 8px;border-top-right-radius: 8px;">
                                                <h2 style="margin: 0;">PATCH</h2>
                                                <span style="
                                                font-weight: 700;
                                                font-size: 18px;
                                                line-height: 22px;
                                                margin-left: 15em;
                                                color: #EF9600;">{{parseFloat(drug.amount_administered).toFixed(2)}}/{{drug.max_dose ? drug.max_dose : 'null'}} {{drug.alias.form}}{{ drug.max_dose && drug.max_dose > 1 ? 's' : ''}} administered in the last 24 hours</span>
                                            </div>
                                            <div>
                                                <table style="border-collapse: collapse;" >
                                                    <tr class="patch-medication-row">
                                                        <td style="width: 10em"><div class="drug-image"><img src="../../assets/icons/medPlaceholder.png" alt=""></div></td>
                                                        <td style="padding:10px">
                                                            <p style="font-size: 1em; font-weight: bold;">{{drug.alias.name.charAt(0).toUpperCase() + drug.alias.name.slice(1)}}</p>
                                                            <p style="font-size: 1em;"><b>Dispensed:</b> <i>{{drug.dispensed_items?.length ? drug.dispensed_items[0].name : 'No item dispensed'}}</i></p>
                                                            <p>{{drug.indication}}</p>
                                                            <p>{{drug.instructions}}</p>
                                                            
                                                        </td>
                                                        <td style="width: 5em; font-weight: bold;">x {{drug.dose}}</td>
                                                        <td style="width: 10em; font-weight: bold;">{{drug.route}}</td>
                                                        <td style="width: 1em"></td>
                                                        <td @click="displayPatchAdminModal = true, selectPatch(drug)" v-if="(!drug.alias.tags.includes('S8') && !drug.alias.tags.includes('s8') || drug.removed) && !drug.completed" style="width: 1em" >
                                                            <div class="administer-button">ADMINISTER</div>
                                                        </td>
                                                        <td @click="displayPatchAdminModal = true, selectPRN(drug)"  style="width: 1em" v-if="(drug.alias.tags.includes('S8') || drug.alias.tags.includes('s8')) && !drug.removed && !drug.completed">
                                                            <div class="administer-button">REMOVE FROM REG</div>
                                                        </td>
                                                        <td  style="width: 1em" v-if="drug.completed">
                                                            <div class="administer-button" style="cursor: inherit">COMPLETED</div>
                                                        </td>
                                                        <td style="width: 0em"></td>
                                                        <td style="width: 0em"></td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else style="margin: 0 auto; padding-top: 5em; display: flex; align-items: center;">
                <i class="pi pi-spin pi-spinner" v-if="loadingPatient || loadingResidentDrugs" style="font-size: 2rem !important;"></i>
                <div v-if="loadingPatient && !loadingResidentDrugs" style="text-align: center;">
                    <h2 style="color: black; margin: 0;" v-if="!loadingAdministration">{{noCharts ? 'No ' + $resident({ plural: true }) + ' are due for administration at this location.' : 'No Location Selected'}}</h2>
                    <p style="font-size: 1.2em; margin: 0;" v-if="!loadingAdministration">Please select {{noCharts ? 'another':'a'}} location to view {{ $resident({ plural: true }) }} due for administration.</p>
                </div>
                <div v-if="loadingAdministration">
                    <h3 style="color: black; margin: 0;" >Waiting for {{ $resident({ plural: true }) }} to be retrieved from location/s.</h3>
                    <p style="font-size: 1.2em; margin: 0;">Please wait...</p>
                </div>
                
            </div>
            
        </div>
        <DOCModal v-if="displayDOCModal" @close="close" @receiveDOC="receiveDOC" :adminSubmission="submitPayload" :loop="loop" :selectedDrugName="selectedDrugName" />
        
        <PRNAdminModal v-if="displayPRNAdminModal" @completePRN="completePRN" @updatePRN="updatePRN" :selectedNIM="selectedNIM" :selectedPRN="selectedPRN" @close="close" @receiveDOC="receiveDOC" :adminSubmission="submitPayload"
        :patientId="patient && patient.uuid ? patient.uuid : ''"  @addInsulinReading="addInsulinReading" :readings="patient && patient.readings ? patient.readings : []"  />
        
        <NIMAdminModal v-if="displayNIMAdminModal" @completeNIM="completeNIM" :selectedNIM="selectedNIM" :selectedPRN="selectedPRN" @close="close" @receiveDOC="receiveDOC" :adminSubmission="submitPayload"
        :patientId="patient && patient.uuid ? patient.uuid : ''"  />
        <!--  :adminSubmission="submitPayload" -->
        <PatchAdminModal :adminSubmission="submitPayload" :adminRound="!selectedPatch.expired" @close="close" v-if="displayPatchAdminModal" @submitIsCompleted="submitIsCompleted" :selectedPatch="selectedPatch" :patientId="patient && patient.uuid ? patient.uuid : ''"  />
        
        <InsulinModal v-if="displayInsulinModal" @completeInsulin="completeInsulin" :patientId="patient && patient.uuid ? patient.uuid : ''" 
        @addInsulinReading="addInsulinReading" :readings="patient && patient.readings ? patient.readings : []" :selectedInsulin="selectedInsulin" @close="close" :adminSubmission="submitPayload" @submitIsCompleted="submitIsCompleted"  />
        
        <SlidingScaleAdminModal v-if="displaySlidingScaleModal" @completeSlidingScaleActivity="completeSlidingScaleActivity" :patientId="patient && patient.uuid ? patient.uuid : ''" 
        @addInsulinReading="addInsulinReading" :readings="patient && patient.readings ? patient.readings : []" :latestInrReading="patient && patient.latest_inr_reading ? patient.latest_inr_reading : null" :selectedDrug="selectedSlidingScaleDrug" @close="close" :adminSubmission="submitPayload" @updateDrug="updateSlidingScaleDrugRemoval" />
        
        <ExpiredAdminNoteModal v-if="displayExpiredNoteModal" @close="close" :selectedExpiredDrug="selectedExpiredDrug" :patientId="patient && patient.uuid ? patient.uuid : ''" />
        <ADRModal v-if="displayADRModal" :patient="patient" @close="displayADRModal = false" />
        
        <AdhocReadingModal 
            v-if="displayAdhocReadingModal" 
            :readingType="selectedAdhocReading" 
            :patientId="patient && patient.uuid ? patient.uuid : ''" 
            @close="closeAdhocReadingModal" 
            @readingCompleted="handleAdhocReadingCompleted"
        />
    </div>
</template>

<script>
import SingleVerify from '@/components/verification/SingleVerify.vue';
import DOCModal from '@/components/modals/DOCModal.vue';
import PRNAdminModal from '@/components/modals/PRNAdminModal.vue';
import PatchAdminModal from '@/components/modals/PatchAdminModal.vue';
import NIMAdminModal from '@/components/modals/NIMAdminModal.vue';
import InsulinModal from '@/components/modals/InsulinModal.vue';
import SlidingScaleAdminModal from '@/components/modals/SlidingScaleAdminModal.vue';
import ExpiredAdminNoteModal from '@/components/modals/ExpiredAdminNoteModal.vue';
import MiniViewMhr from '../patientViewComponents/MiniViewMhr.vue';
import ADRModal from '@/components/modals/ADRModal.vue';
import AdhocReadingModal from '@/components/modals/AdhocReadingModal.vue';
import ReadingsModal from '@/components/modals/ReadingsModal.vue';
import { getRealAdrs } from '@/services/nkda';
import { isBeforeToday } from '@/services/dates';

import MimsImage from '../mims/MimsImage.vue';
import axios from 'axios';

export default{
    props:['spec_cons','loadMims','adminChart', 'patient', 'loadingPatient', 'emptyList', 'loadingAdministration', 'expiredCharts',
    'noCharts', 'prns', 'patches', 'loadingPRNs', 'prnMode', 'loadingNIMs', 'nims', 'hiddenTags', 'loadingResidentDrugs', 'dailyDoses', 'loadingDailyDoses'],
    components:{
        SingleVerify,
        DOCModal,
        PRNAdminModal,
        PatchAdminModal,
        NIMAdminModal,
        InsulinModal,
        SlidingScaleAdminModal,
        ExpiredAdminNoteModal,
        // MimsImage,
        MiniViewMhr,
        ADRModal,
        AdhocReadingModal,
        ReadingsModal
    },
    data(){
        return{
            displayReadingsModal: false,
            displayInsulinModal: false,
            displaySlidingScaleModal: false,
            selectedSlidingScaleDrug: '',
            mimsApiKey: localStorage.getItem('mimsApiKey'),
            displayPRNAdminModal: false,
            displayNIMAdminModal:false,
            displayPatchAdminModal:false,
            discardAvailable:false,
            displayExpiredNoteModal: false,
            // displayPRN: false,
            // displayNIM: false,
            loop:false,
            displayDOCModal: false,
            infoADRTab: 'ADR',
            displayADRModal: false,
            removeFromSafe:[],
            selectedPRN:'',
            selectedNIM:'',
            selectedPatch:'',
            // removeFromRegisterPayload is the MAPPED payload of items within the removeFromSafe
            removeFromRegisterPayload:[],
            doseOmittedCode:[
              'A',
              'F',
              'H',
              'L',
              'S',
              'S/A',
              'V',
              'A/T',
              'C',
              'N',
              'N/R',
              'O',
              'R',
              'W',
              'W/R'
            ],
            packedPayload:[],
            NonpackedPayload:[],
            submitPayload: {},
            bulkItemsCompleted: 0,
            selectedDrugName: '',
            redoingAdministration: {},
            expiredMeds:null,
            expiredOptions:[
                {name:'Create Admin Note', value:'Note'}
            ],
            selectedExpiredOption:'',
            selectedExpiredDrug:'',
            openMhrMiniView: false,
            selectedAdhocReading: null,
            adhocReadingOptions: [
                {label: 'Sedation Score', value: 'sedation'},
                {label: 'INR Reading', value: 'inr'},
                {label: 'Blood Glucose', value: 'bgl'},
                {label: 'Serum Creatinine', value: 'creatinine'}
            ],
            displayAdhocReadingModal: false,
        }
    },
    methods:{
        isMedicationExpired(item) {
            if (item.script_status === 'ceased' || item.script_status === 'cancelled') {
                return false;
            }
            if (item.deleted_at) {
                return false;
            }
            if (this.isErxChartExpired) {
                return true;
            }
            if (item.script_status === 'expired') {
                return true;
            }
            if (item.stop_date) {
                return isBeforeToday(item.stop_date);
            }
            return false;
        },
        openAdhocReadingModal() {
            if (this.selectedAdhocReading) {
                this.displayAdhocReadingModal = true;
            }
        },
        closeAdhocReadingModal() {
            this.displayAdhocReadingModal = false;
            this.selectedAdhocReading = null;
        },
        handleAdhocReadingCompleted(reading) {
            console.log("Adhoc reading completed", reading);
            this.closeAdhocReadingModal();
            this.$emit('updatePatientReading', reading);
        },
        viewFMhrFile() {
            console.log("opening mhr modules, state ");
            this.openMhrMiniView=!this.openMhrMiniView;
        },
        createExpiredNote(drug){
            this.selectedExpiredDrug = drug;
            this.displayExpiredNoteModal = false;
        },
        resupplyDrug(drug){
            console.log('this is the drug requesting to be resupplied', drug);
            drug.loadingSupply = true;
            
            axios.post('resupply/create', {prescription_id: drug.prescription_id}, this.$store.state.header).then(res=>{
                console.log('this is the res', res.data);
                drug.loadingSupply = false;
                drug.requestedSupply = true;
            }).catch(err=>{
                console.log('this is the resupply error', err);
                drug.loadingSupply = false;
                drug.requestedSupply = true;
                drug.alreadyRequested = true;
            })
        },
        expiryBool(date) {
            const targetDate = new Date(date)
            console.log(targetDate)
            const currentDate = new Date();
            const timeDifference = targetDate.getTime() - currentDate.getTime();
            // Convert milliseconds to days
            const daysDifference = timeDifference / (1000 * 60 * 60 * 24);
            if (daysDifference <= 14) {
                return true
                } else {
                return false
                }
        },
        formatExpiry(date) {
            const targetDate = new Date(date)
            const currentDate = new Date();
            const timeDifference = targetDate.getTime() - currentDate.getTime();
            // Convert milliseconds to days and hours remaining
            const daysDifference = timeDifference / (1000 * 60 * 60 * 24);
            const truncatedDaysDifference = Math.trunc(daysDifference);
            // we use ceiling value to prevent displaying 0 days and 0 hours when hoursDiff is < 0.5 but > 0
            const hoursDifference = Math.ceil((daysDifference - truncatedDaysDifference) * 24);
            const template = `
                ${truncatedDaysDifference} 
                ${((truncatedDaysDifference === 1 ? 'day' : 'days'))} 
                and ${hoursDifference} ${(hoursDifference === 1 ? 'hour' : 'hours')}
                `;
            return template; // displays as X day/s and Y hour/S
        },
        showPatch(){
            this.$emit('togglePatch', true);
            setTimeout(()=>{
                if(this.patient.displayPatch){
                    console.log('calling the retrieve in selected')
                    this.retrievePatch()
                }
            },100)
            
        },
        showPRN(){
            this.$emit('togglePRN', true);
            setTimeout(()=>{
                if(this.patient.displayPRN){
                    this.retrievePRN()
                } 
                // else{
                //     this.$emit('retrieveExpired')
                // }
            },100)
            
        },
        showNIM(){
            this.$emit('toggleNIM', true);
            setTimeout(()=>{
                if(this.patient.displayNIM){
                    this.retrieveNIM()
                }
            },100)
            
        },
        showDailyDoses(){
            this.$emit('toggleDailyDoses', true);
            setTimeout(()=>{
                if(this.patient.displayDailyDoses){
                    this.retrieveDailyDoses()
                }
            },100)
            
        },
        addEffective(effective, drug){
            
            this.$emit('submitEffective', {
                effective: effective,
                prn_id: drug.administration_id
            });
        },
        close(value){
            if(value){
                this.displayDOCModal = false;
                this.displayPRNAdminModal = false;
                this.displayNIMAdminModal = false;
                this.displayInsulinModal = false;
                this.displaySlidingScaleModal = false;
                this.displayPatchAdminModal = false;
                this.displayExpiredNoteModal = false; 
            }
        },
        retrievePRN(){
            this.$emit('retrievePRNs', true);
        },
        retrieveNIM(){
            this.$emit('retrieveNIMs', true);
        },
        retrieveDailyDoses(){
            this.$emit('retrieveDailyDoses', true);
        },
        retrievePatch(){
            this.$emit('retrievePatches', true);
        },
        selectPRN(drug){
            this.selectedPRN = drug;
            if(this.selectedPRN.stock_items && this.selectedPRN.stock_items.length){
                this.selectedPRN.stock_items = this.selectedPRN.stock_items.filter((item, index) => this.selectedPRN.stock_items.indexOf(item) === index);
            }
            
            this.selectMedLoad(drug, false);
        },
        selectNIM(drug){
            this.selectedNIM = drug;
            this.selectMedLoad(drug, false);
        },
        selectPatch(drug){
            this.selectedPatch = drug;
            this.selectMedLoad(drug, false);
        },
        selectInsulin(drug){
            this.selectedInsulin = drug;
            this.selectMedLoad(drug, false);
        },
        selectSlidingScaleDrug(drug){
            this.selectedSlidingScaleDrug = drug;
            this.selectMedLoad(drug, false);
        },
        getDrugId(value){
            if(value){
                console.log('this is the drug containing drug retrieval id', value);
                if(value.id){
                    this.adminChart.forEach(chart=>{
                        if(chart.uuid == value.id){
                            chart.removed = true;
                            chart.drug_safe_retrieval = value.drug_safe_retrieval;
                        }
                    })
                    setTimeout(()=>{
                        this.close(true);
                    },200)
                }
            }
        },
        updatePRN(value){
            if(value){
                console.log('this is the drug containing drug retrieval id', value);
                if(value.id){
                    this.prns.forEach(chart=>{
                        if(chart.uuid == value.id){
                            chart.removed = true;
                            chart.drug_safe_retrieval = value.drug_safe_retrieval;
                        }
                    })
                }
            }
        },
        updateNIM(value){
            if(value){
                console.log('this is the drug containing drug retrieval id', value);
                if(value.id){
                    this.nims.forEach(chart=>{
                        if(chart.uuid == value.id){
                            chart.removed = true;
                            chart.drug_safe_retrieval = value.drug_safe_retrieval;
                        }
                    })
                }
            }
        },
        addInsulinReading(value){
            if(value){
                console.log('this is the insulin update (reading)', value);
                this.$emit('updatePatientReading', value);
                this.displayInsulinModal = false;
                this.displaySlidingScaleModal = false;
            }
        },
        completePRN(value){
            if(value){
                console.log('this is the drug completed prn', value);
                this.$emit('completePRN', value);
            }
        },
        completeNIM(value){
            if(value){
                console.log('this is the drug containing drug retrieval id, NIM', value);
                this.$emit('completeNIM', value);
                if(value){
                    this.nims.forEach(chart=>{
                        if(chart.uuid == value.id){
                            chart.completed = true;
                            this.$emit('completedNIM', value);
                        }
                    })
                } 
            }
        },
        completeInsulin(value){
            if(value){
                console.log('this is the drug containing insulin', value.uuid);
                this.$emit('isCompleted',{item:value.uuid} );
                this.adminChart.forEach(chart=>{
                    if(chart.uuid == value.uuid){
                        chart.completed = true;
                        chart = {
                            latest_administration: {
                                uuid: value?.response.uuid,
                                quantity: value?.quantity.toString()
                            },
                            ...chart
                        };
                        // fallback incase component is destroyed and this.adminChart resets
                        localStorage.setItem(chart.chart_id, value?.response?.uuid);
                    }
                })
            }
        },
        completeSlidingScaleActivity(value){
            if(value){
                console.log('this is the drug containing sliding scale', value.id);
                this.$emit('isCompleted',{item:value.id} );
                this.adminChart.forEach(chart=>{
                    if(chart.uuid == value.id){
                        chart.completed = true;
                        chart = {
                            latest_administration: {
                                uuid: value?.response.uuid,
                                quantity: value?.response.quantity ? value.response.quantity.toString() : ''
                            },
                            ...chart
                        };
                        // fallback incase component is destroyed and this.adminChart resets
                        localStorage.setItem(chart.chart_id, value?.response?.uuid);
                    }
                })
            }
        },
        updateSlidingScaleDrugRemoval(value){
            if(value){
                console.log('this is the sliding scale drug retrieved from safe', value);
                if(value.id){
                    this.adminChart.forEach(chart=>{
                        if(chart.uuid == value.id){
                            chart.removed = true;
                            chart.drug_safe_retrieval = value.drug_safe_retrieval;
                        }
                    })
                }
            }
        },
        receiveDOC(value){
            console.log('THIS IS THE DOC RECEIVED', value);
            if(value){
                if(value.bulk_meds){
                    this.adminChart.forEach(chart=>{
                        value.bulk_meds.forEach((item, index)=>{
                            console.log("bulk meds from sig response");
                            console.log(value);
                            console.log('this is the chart uuid', chart.uuid, item.calendar_item_id, index);
                            if(chart.uuid == item.calendar_item_id){
                                console.log('match this');
                                chart.doc = item?.doc;
                                chart.completed = true;
                                chart = {
                                    latest_administration: item?.response,
                                    ...chart
                                };
                                chart = {
                                    latest_administration: item?.response,
                                    ...chart
                                };
                                this.$emit('isCompleted', {item: chart.uuid});
                                // fallback incase component is destroyed and this.adminChart resets
                                localStorage.setItem(chart.chart_id, item?.response?.uuid);
                            }
                        })
                    })
                } else{
                    this.adminChart.forEach(chart=>{
                        if(chart.uuid == value.id){
                            chart.doc = value.doc.value;
                            chart.completed = true;
                            chart = {
                                latest_administration: value?.response,
                                ...chart
                            };
                            chart = {
                                latest_administration: value?.response,
                                ...chart
                            };
                            this.$emit('isCompleted', {item: chart.uuid});
                            // fallback incase component is destroyed and this.adminChart resets
                            localStorage.setItem(chart.chart_id, value?.response?.uuid);
                        }
                    })
                }
                
            }
        },
        removeDrugFromRegister(drug){
            let notes = "";
            if(drug.dose_unit.toLowerCase() != drug.container_unit.toLowerCase()){
                notes = "Administering " + drug.dose + " " + drug.dose_unit + "/s"; 
            }

            let qty = parseFloat(drug.dose_container_amount ?? drug.dose);
            let ceilingQty = Math.ceil(qty);
                
            let discard_amount = parseFloat(ceilingQty - qty).toFixed(2);
                
            if(discard_amount > 0){
                console.log("discard amount is greater than 0: " + discard_amount);
            }else{
                console.log("discard amount is not greater than 0: " + discard_amount);
            }
            

            this.removeFromRegisterPayload = 
                {
                    prescription_uuid: drug.prescription_id,
                    prescriber_uuid:drug.prescriber_id,
                    stock_item_id:drug.stock_items[0].uuid,
                    quantity: qty.toString(),
                    patient_id: this.patient.uuid,
                    dose_quantity: drug.dose,
                    dose_unit: drug.dose_unit,
                    notes: notes,
                    ...((discard_amount > 0) && { discard_amount: discard_amount.toString() }), // conditionally adds discard_amount to payload
                    
                }
            this.discardAvailable = discard_amount > 0 ? discard_amount + " " + drug.container_unit + "/s" : false;
            
        },
        mapPackedPayload(successfulAdministration){
            console.log('calling map packed payload function', successfulAdministration)
            this.packedPayload = [];
            this.loop = true;
            this.getIncompletePacked.forEach(med=>{
                this.packedPayload.push(
                    {
                        administered: successfulAdministration,
                        drug_safe_retrieval: '',
                        calendar_item_id:med.uuid,
                        chart_id: med.chart_id,
                        doc:'',
                        dose: med.dose,
                        note:'',
                        drug: med.alias.name,
                        dose_unit: med.dose_unit
                    }
                )
            });
            this.submitPayload = {
                doc: null,
                bulk_meds: this.packedPayload
            };
        },
        mapNonpackedPayload(successfulAdministration){
            console.log('calling map unpacked payload function', successfulAdministration)
            this.NonpackedPayload = [];
            this.loop = true;
            this.getIncompleteNonPacked.forEach(med=>{
                this.NonpackedPayload.push(
                    {
                        administered: successfulAdministration,
                        drug_safe_retrieval: '',
                        calendar_item_id:med.uuid,
                        chart_id: med.chart_id,
                        doc:'',
                        dose: med.dose,
                        note:'',
                        drug: med.alias.name,
                        dose_unit: med.dose_unit
                    }
                )
            });
            this.submitPayload = {
                doc: null,
                bulk_meds: this.NonpackedPayload
            };
        },
        selectDOC(drug){
            drug.status = document.getElementById(`${drug.chart_id}-doc-admin`).value;
            console.log('this is the drug doc and object', drug.status, drug);
        },
        redoAdminChart(chart){
            console.log('CHART', chart);
            let currentChart = this.adminChart.filter((item) => {
                return chart.chart_id == item.chart_id;
            });
            let administration_id = chart.latest_administration?.uuid || currentChart[0]?.latest_administration?.uuid || localStorage.getItem(chart.chart_id);
            let updateAdminPayload = {
                administration_id
            };
            console.log('this is the payload to send to /update-administration-event', updateAdminPayload);
            
            // begin redoing of administration event
            this.redoingAdministration[chart.chart_id] = {
                loading: true,
                error: false
            };

            axios.post("/update-administration-event", updateAdminPayload, this.$store.state.header).then(res => {
                console.log('this is the res from endpoint: /update-administration-event', res);
                // final state for redo: tick and cross buttons restored
                this.redoingAdministration[chart.chart_id] = {
                    loading: false,
                    error: false
                };
                // reset the chart item in the FE for current session of activity
                chart.completed = false;
                chart.doc = '';
            }).catch(err => {
                console.error('this is the error from endpoint: /update-administration-event', err);
                this.redoingAdministration[chart.chart_id] = {
                    loading: false,
                    error: true
                };
            });
        },
        submitPrimeSignature(drug, status){
            this.$emit('primeSignature', drug, status);
        },
        submitIsCompleted(value){
            console.log('RECEIVED THIS FROM SUBMIT IS COMPLETED', value);
            
            if(value){
                if(value.bulk_meds){
                    this.adminChart.forEach(chart=>{
                        value.bulk_meds.forEach((item, index)=>{
                            console.log('this is the chart uuid', chart.uuid, item.calendar_item_id, index);
                            if(chart.uuid == item.calendar_item_id){
                                this.$emit('isCompleted', {item: chart.uuid});
                                console.log('match this');
                                chart.completed = true;
                                // reference administration id for any redo operation
                                chart = {
                                    latest_administration: item?.response,
                                    ...chart
                                };
                                // fallback incase component is destroyed and this.adminChart resets
                                localStorage.setItem(chart.chart_id, item?.response?.uuid);
                            }
                        })
                    })
                } else{
                    this.$emit('isCompleted', value);
                    this.adminChart.forEach(chart=>{
                        console.log('this is the chart uuid', chart, chart.calendar_item_id, value.item);
                        if(chart.uuid == value.item){
                            console.log('match this');
                            chart.completed = true;
                            // reference administration id for any redo operation
                            chart = {
                                latest_administration: value?.response,
                                ...chart
                            };
                            // fallback incase component is destroyed and this.adminChart resets
                            localStorage.setItem(chart.chart_id, value?.response?.uuid);
                        }
                    })
                }
                
            }
            this.removeFromSafe = [];
        },
        updateRemovalList(drug){
            drug.selectedForRemoval = !drug.selectedForRemoval; 
            if(!drug.selectedForRemoval){
                this.removeFromSafe.splice(this.removeFromSafe.indexOf(drug), 1)
            } else{
                this.removeFromSafe.push(drug);
            }
            console.log('this is the remove from safe list', this.removeFromSafe);
            this.mapRemoveFromRegisterPayload();
        },
        formatNotesForSignOff(drug, administered) {
                let notes;
                const doseContainerQty = (drug) => {
                    let containerConstant = drug?.container_constant ?? 1;
                    let myQty = parseFloat(parseFloat(drug.dose) / containerConstant);
                    return myQty.toFixed(2);
                };
                if (administered) {
                    let date = new Date();
                    notes = `Dose administered.
Date: ${date.toLocaleDateString('en-AU')}
Time of administration: ${date.toLocaleTimeString('en-AU')}
Drug name: ${drug.alias.name}
Dose: ${parseFloat(drug.dose).toFixed(2)} ${drug.dose_unit.toLowerCase()}/s ${(drug.container_unit.toLowerCase() === 'ampoule' && drug.container_unit.toLowerCase() !== drug.dose_unit.toLowerCase()) ? '[' + doseContainerQty(drug) + ' Ampoule(s)' + ']': ''}
Administration Route: ${drug.route}
                    `;
                } else notes = '';
                return {
                    notes: notes
                };
        },
        selectMedLoad(drug, administered){
            this.loop = false;
            this.selectedDrugName = drug.alias.name;
            if(!drug.expired){
                this.submitPayload = {
                    drug: drug,
                    administered: administered,
                    drug_safe_retrieval: drug.drug_safe_retrieval ? drug.drug_safe_retrieval : (drug.retrieved_drugs?.length > 0 ? drug.retrieved_drugs[0] : ''), // if user logs out, the retrieved drug will be loaded from the backend
                    calendar_item_id: drug.uuid ? drug.uuid : 'no calendar id',
                    chart_id: drug.chart_id ? drug.chart_id : drug.uuid,
                    patch_site: null,
                    doc:'',
                    dose: parseFloat(drug.dose).toFixed(2),
                    notes: this.formatNotesForSignOff(drug, administered).notes,
                    reading: '',
                } 
            } else{
                this.submitPayload = {
                    administered: administered,
                    drug_safe_retrieval: drug.drug_safe_retrieval ? drug.drug_safe_retrieval : '',
                    calendar_item_id: null,
                    chart_id: drug.uuid,
                    patch_site: null,
                    doc:'',
                    dose: parseFloat(drug.dose).toFixed(2),
                    reading: '',
                }
            }
        },
        getLastEvent(lastChartAdmin) {
            let adminAt = "N/A";

            if (lastChartAdmin && lastChartAdmin.length) {
                adminAt = lastChartAdmin.reduce((latestDate, admin) => {
                    const administeredDate = new Date(admin.administered_at);
                    
                    if (!latestDate || administeredDate > new Date(latestDate)) {
                        return admin.administered_at;
                    } else {
                        return latestDate;
                    }
                }, null);
            }

            return adminAt;
        }
    },
    mounted(){
    },
    computed:{
        realAdrs(){
            return getRealAdrs(this.patient && this.patient.adr);
        },
        uniqueSpecCons(){
            let b = this.spec_cons &&  this.spec_cons.special_considerations ?  this.spec_cons.special_considerations : [];
            const set = new Set();
            const result = b.filter((o) => {
                if (set.has(o.name)) return false;
                set.add(o.name);
                return true;
            });
            return result;
        },
        sortedPacked(){
            let b = [...this.getPacked];
            return b.sort((a,b) => {
                if(a.completed < b.completed) return -1;
                if(a.completed > b.completed) return 1;
                return 0;
            });
        },
        getIncompleteInsulin(){
            if(this.adminChart && !this.isErxChartExpired){
                return this.adminChart.filter(item=>item.chart_type == 'insulin' && !item.completed);
            }   else{
                return []
            }
        },
        lastBGLReading(){
            if(this.patient.readings.length){
                let lastReading = new Date(this.patient.readings[0].created_at);
                let currentTime = new Date();
                lastReading = lastReading.getTime()
                currentTime = currentTime.getTime()
                let timeDiff = (currentTime - lastReading)/1000/60;
                return timeDiff
            } else{
                return null
            }
        },
        getInsulin(){
            if(this.adminChart && !this.isErxChartExpired){
                return this.adminChart.filter(item=>item.chart_type == 'insulin');
            } else{
                return []
            }
            
        },
        getPacked(){
            if(this.adminChart && !this.isErxChartExpired){
                return this.adminChart.filter(item=>item.chart_tags.includes('packed'));
            } else{
                return []
            }
            
        },
        getIncompletePacked(){
            if(this.adminChart && !this.isErxChartExpired){
                return this.adminChart.filter(item=>item.chart_tags.includes('packed') && !item.completed)
            } else{
                return []
            }
           
        },
        getCompletePacked(){
            if(this.adminChart && !this.isErxChartExpired){
                return this.adminChart.filter(item=>item.chart_tags.includes('packed') && item.completed)
            } else{
                return []
            }
            
        },
        getNonPacked(){
            if(this.adminChart && !this.isErxChartExpired){
                return this.adminChart.filter(item=>(!item.chart_tags.includes('packed') && (!item.alias.tags.includes('S8') && !item.alias.tags.includes('s8') && (!item.stock_items || !item.stock_items.length )) && item.chart_type != 'insulin'));
            } else{
                return []
            }
            
        },
        getIncompleteNonPacked(){
            if(this.adminChart && !this.isErxChartExpired){
                return this.adminChart.filter(item=>(!item.chart_tags.includes('packed') && (!item.alias.tags.includes('S8') && !item.alias.tags.includes('s8') && (!item.stock_items || !item.stock_items.length )) && !item.completed && item.chart_type != 'insulin'));
            } else{
                return []
            }
            
        },
        getIncompleteS8(){
            if(this.adminChart && !this.isErxChartExpired){
                let filtered = this.adminChart.filter(item=>!item.chart_tags.includes('packed') && (item.alias.tags.includes('S8') || item.alias.tags.includes('s8') || item.alias.tags.includes('S11') || item.alias.tags.includes('s11') || (item.stock_items && item.stock_items.length)) && !item.completed);
                return filtered;
            } else{
                return []
            }
        },
        getS8(){
            if(this.adminChart && !this.isErxChartExpired){
                let filtered = this.adminChart.filter(item=>!item.chart_tags.includes('packed') && (item.alias.tags.includes('S8') || item.alias.tags.includes('s8') || item.alias.tags.includes('S11') || item.alias.tags.includes('s11') || (item.stock_items && item.stock_items.length)));
                filtered.forEach(chart=>{
                    chart.removed = chart.retrieved_drugs?.length > 0 ? true : false;
                    chart.selectedForRemoval = false;
                });
                return filtered;
            } else{
                return []
            }
        },
        displayExpiredCharts() {
            // `patient` is null while the parent is still loading - guard it the same way the
            // neighbouring computeds (realAdrs, isErxChartExpired) already do.
            if(this.patient?.displayNIM) {
                return false;
            }
            return true;
        },
        isErxChartExpired() {
            return isBeforeToday(this.patient?.erx_chart?.end_date);
        },
        allExpiredCharts() {
            let expired = this.expiredCharts ? [...this.expiredCharts] : [];
            if (this.isErxChartExpired) {
                // If the entire chart is expired, merge all other medications into the expired list
                if (this.adminChart) {
                    expired = [...expired, ...this.adminChart];
                }
                if (this.prns) {
                    expired = [...expired, ...this.prns];
                }
                if (this.patches) {
                    expired = [...expired, ...this.patches];
                }
                if (this.nims) {
                    expired = [...expired, ...this.nims];
                }
            }

            // Deduplicate by UUID always
            const uniqueExpired = [];
            const seenUuids = new Set();
            expired.forEach(chart => {
                if (chart && chart.uuid && !seenUuids.has(chart.uuid)) {
                    uniqueExpired.push(chart);
                    seenUuids.add(chart.uuid);
                }
            });
            return uniqueExpired;
        }
    }
}
</script>

<style lang="scss" scoped>

.dummy-icon{
    width: 50px !important;
}
.administered{
    background-color: #00AD50 !important;
    color: white !important;
    p{
        margin: 0; 
        padding: 0; 
        font-weight: bold; 
        width: fit-content
    }
}

.not-administered{
    background-color: #E04F39 !important;
    color: white !important;
    p{
        margin: 0; 
        padding: 0; 
        font-weight: bold; 
        width: fit-content
    }
}
.medication-group-header{
    h2{
        font-size: 18px;
    }
    span{
        font-size: 18px;
    }
}

.medication-group{
    table{
        td{
            font-size: 16px;
            p{
                margin: 0;
            }
        }
    }
}
.admin-chart-header{
    display: flex;
    padding: 1em;
    padding-top: 0;
}

.drug-image{
    // height: 75px;
    // width: 75px;
    // background-color: white;
    padding-left: 15px;
    img{
        max-height: 100px;
        max-width:120px;
        width: auto;
        height: auto;
    }
}

.administer-button{
    box-sizing: border-box;
    width: 187px;
    background: #FFFFFF;
    border: 2px solid #000000;
    border-radius: 6px;
    margin: 0 auto;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    cursor: pointer;
}
.grey-field{
    background-color: #f3f4f4 !important;
    border: none !important;
}

.four-table-row{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}

.four-column-entry{
    width: 22%;
    min-width: 120px;
    margin-right: 10px;
    margin-bottom: 20px;
}

.two-column-row{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.two-column-entry{
    width: 45%;
    min-width: 200px;
    margin-right: 10px;
}

.medication-group{
    // margin-top: 10px;
    margin-bottom: 10px;
    h2{
        color: white;
        width: fit-content;
    }
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
}

.packed-medication-row{
     background-color: rgba(8, 112, 220, 0.2);  
     td{
         padding: 10px;
     }   
}

.scheduled-medication-row{
     background-color: rgba(224, 79, 57, 0.2);
     td{
         padding: 10px;
     }   
}

.insulin-medication-row{
    background-color: #FFE67C;
     td{
         padding: 10px;
     }   
}

.non-packed-medication-row{
     background-color: #F3F4F4;
     td{
         padding: 10px;
     }   
}

.prn-medication-row{
    background-color: #94D6D0;
    td{
        padding: 10px;
    }
}

.nim-medication-row{
    background-color: rgba(39, 65, 136, 0.35);
    td{
        padding: 10px;
    }
}

.patch-medication-row{
    background-color: #FED182;
    td{
        padding: 10px;
    }
}




.pi-check, .pi-times, .pi-sign-out, .pi-lock-open, .pi-eject, .pi-replay{
    background-color: white;
    padding: 10px;
    font-weight: bold;
    border-radius: 8px;
    color: grey;
    cursor: pointer;
}



.tag {
  pointer-events: none;
  background-color: white;
  border: none;
  color: black;
  padding: 5px 20px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  border-radius: 10px;
}
.similar-name-tag-patient-general {
  display: block;
  background-color: #ff9800;
  color: white;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 0.9rem;
  font-weight: bold;
  border: 2px solid white;
  width: fit-content;
  text-align: left;
}

</style>
